{
  "\"chart.tooltip.substat.phase\"": "Fáze {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}",
  "\"chart.tooltip.substat.pv_string\"": "{inverterName}, String {stringNumber}",
  "animation.battery": "Baterie",
  "animation.boiler": "Bojler",
  "animation.consumption": "Dům",
  "animation.electrical_grid": "Síť",
  "animation.hp": "Tepelko",
  "animation.photovoltaics": "FVE",
  "animation.wallbox": "Wallbox",
  "animation.wind": "Vítr",
  "app_messages.battery_max_soc": "Nabití baterie na nastavené maximální SOC {maxSoc, number, ::.##}%",
  "app_messages.battery_min_soc": "Vybití baterie na nastavené minimální SOC {minSoc, number, ::.##}%",
  "app_messages.body.battery_max_soc": "Aktuální úroveň nabití baterie je {currentSoc, number, ::.##}%.",
  "app_messages.body.battery_min_soc": "Aktuální úroveň nabití baterie je {currentSoc, number, ::.##}%.",
  "app_messages.body.heat_pump_limit_exceeded": "Byl překročen dnešní limit spotřeby tepelného čerpadla. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.heat_water_limit_exceeded": "Byl překročen dnešní limit ohřevu vody. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.heat_water_max_temperature": "Dnes již došlo k nahřátí bojleru na požadovanou maximální teplotu {maxTemperature, number, ::.##}°C.",
  "app_messages.body.home_limit_exceeded": "Byl překročen dnešní limit spotřeby domácnosti. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.inverter_production_mwh": "Letos vám vaše fotovoltaická elektrárna již vyrobila {inverterProductionValue, number, ::.##} MWh.",
  "app_messages.body.spot_daily_prediction": "Denní předpověď: {pvPrediction, select, true {Výroba elektrárny: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Běžná spotřeba domu: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Dispoziční akumulace baterie: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Dispoziční akumulace bojleru: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Tepelné čerpadlo je {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Zbývající energie pro prodej přebytků je {salePredictionValue, number, ::.##} kWh. } other {} }",
  "app_messages.body.spot_daily_summary": "Dnes na spotu: {nothingToReport, select, true {Není nic v plánu.} other { {energyForSale, select, true {V plánu je ranní prodej do sítě. } other {} } {negativeIntervals, select, false {} other {Záporná cena ({negativeIntervals}), při které se omezí přetok. } } {chargingIntervals, select, false {} other {Plán nabíjení baterie ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Plán vybíjení baterie do sítě ({dischargingIntervals}). } } } }",
  "app_messages.body.spot_negative_price_start": "Aktuální cena na spotu je po odečtení provize záporná. Provize nastavená v Infigy je ve výši {spotOffsetPrice, number, ::.##} Kč. Aktuální cena spotu je {spotNegativePrice, number, ::.##} Kč.",
  "app_messages.body.spot_negative_price_stop": "Aktuální cena na spotu již není záporná a je ve výši {spotNegativePrice, number, ::.##} Kč. Provize je v Infigy nastavená ve výši {spotOffsetPrice, number, ::.##} Kč",
  "app_messages.body.wallbox_limit_exceeded": "Byl překročen dnešní limit nabíjení elektromobilu. Limit je {value, number, ::.##} kWh.",
  "app_messages.body.wallbox_stop_charging": "V tomto cyklu bylo dodáno {wallboxConsumptionCycleValue, number, ::.##} kWh energie.",
  "app_messages.button": "Smazat",
  "app_messages.cancel": "Zrušit",
  "app_messages.confirm": "Smazat",
  "app_messages.confirm.title": "Opravdu chcete smazat všechny zprávy?",
  "app_messages.detail_dialog.close": "Přečteno",
  "app_messages.heat_pump_limit_exceeded": "Byl překročen dnešní limit spotřeby tepelného čerpadla",
  "app_messages.heat_water_limit_exceeded": "Byl překročen dnešní limit ohřevu vody",
  "app_messages.heat_water_max_temperature": "Dosažena požadovaná maximální teplota vody",
  "app_messages.home_limit_exceeded": "Byl překročen dnešní limit spotřeby domácnosti",
  "app_messages.inverter_connected": "Navázání komunikace se střídačem",
  "app_messages.inverter_disconnected": "Ztráta komunikace se střídačem",
  "app_messages.inverter_production_mwh": "Milník ve výrobě FVE",
  "app_messages.load_more": "Načíst více",
  "app_messages.no_messages": "Zatím zde nejsou žádné notifikace",
  "app_messages.spot_daily_prediction": "Denní předpověď",
  "app_messages.spot_daily_summary": "Denní souhrn plánu spotu",
  "app_messages.spot_negative_price_start": "Cena spotu je záporná",
  "app_messages.spot_negative_price_stop": "Cena spotu již není záporná",
  "app_messages.spot_start_charging_battery": "Začalo nabíjení baterie dle spotové ceny",
  "app_messages.spot_start_discharging_battery": "Začalo vybíjení baterie do sítě dle spotové ceny",
  "app_messages.spot_stop_charging_battery": "Nabíjení baterie dle spotové ceny bylo ukončeno",
  "app_messages.spot_stop_discharging_battery": "Vybíjení baterie do sítě dle spotové ceny bylo ukončeno",
  "app_messages.test": "Testovací notifikace",
  "app_messages.title": "Smazat všechny zprávy",
  "app_messages.utility_loss_start": "Zaznamenali jsme výpadek distribuční sítě",
  "app_messages.utility_loss_stop": "Výpadek distribuční sítě byl odstraněn",
  "app_messages.wallbox_limit_exceeded": "Byl překročen dnešní limit nabíjení elektromobilu",
  "app_messages.wallbox_start_charging": "Začalo nabíjení elektromobilu",
  "app_messages.wallbox_stop_charging": "Nabíjení elektromobilu bylo ukončeno",
  "app_update_overlay.subtitle": "Prosím vyčkejte. Po dokončení aktualizace se aplikace restartuje a okno v prohlížeči se automaticky obnoví",
  "app_update_overlay.title": "Aktualizace probíhá",
  "audit_log.error": "Chyba při načítání",
  "audit_log.item.author": "Autor",
  "audit_log.item.date": "Datum",
  "audit_log.item.payload": "Událost",
  "audit_log.item.type": "Typ",
  "audit_log.title": "Audit Log",
  "audit_log_delete.button": "Smazat",
  "audit_log_delete.cancel": "Zrušit",
  "audit_log_delete.confirm": "Smazat",
  "audit_log_delete.confirm.title": "Opravdu chcete smazat všechny záznamy v audit logu?",
  "audit_log_delete.title": "Smazat audit log",
  "azRouters.add": "Přidat nový AZ router",
  "azRouters.addButton": "Přidat",
  "azRouters.clientId": "Modbus ID",
  "azRouters.clientId.value": "Modbus ID: {id}",
  "azRouters.counts": "OK {ok} / Chyb {err}",
  "azRouters.empty": "Nejsou nakonfigurovány žádné AZ routery",
  "azRouters.name": "Název",
  "azRouters.status.error": "Chyba",
  "azRouters.status.ok": "OK",
  "azRouters.status.starting": "Spouští se",
  "azRouters.title": "AZ routery",
  "bez_dodavatele.business_flexibility.title": "Obchodní flexibilita",
  "bez_dodavatele.enabled": "Integrace zapnuta",
  "bez_dodavatele.region": "Kód kraje",
  "bez_dodavatele.title": "bezDodavatele",
  "boiler.blocking": "Blokace ohřevu",
  "boiler.common": "Obecné informace",
  "boiler.common.phase_3": "Fáze 3:",
  "boiler.common.power": "Aktuální odběr",
  "boiler.common.power.phase_1": "Fáze 1:",
  "boiler.common.power.phase_2": "Fáze 2:",
  "boiler.common.power_today": "Dnešní spotřeba:",
  "boiler.common.power_year": "Roční spotřeba:",
  "boiler.common.temperature": "Aktuální teplota",
  "boiler.common.total": "Celková spotřeba",
  "boiler.settings": "Nastavení",
  "boiler.settings.hdo": "Řízení běžného ohřevu dle HDO časů",
  "boiler.settings.hdo.subtitle": "Časy pro HDO musí být nastaveny v obecném nastavení",
  "boiler.settings.min_soc": "Blokace ohřevu při výpadku sítě",
  "boiler.settings.min_soc.subtitle": "Nabití baterie, od kterého dojde k blokaci ohřevu při výpadku sítě",
  "boiler.settings.min_soc_utility": "Blokace ohřevu při dostupné síti",
  "boiler.settings.min_soc_utility.subtitle": "Nabití baterie, od kterého dojde k blokaci ohřevu",
  "boiler.settings.spot-hi": "Blokovat ohřev při vysoké ceně spotu",
  "boiler.settings.spot-mi": "Blokovat ohřev při střední ceně spotu",
  "boiler.settings.temp": "Nastavená teplota",
  "boiler.settings.temp.subtitle": "Běžná teplota, která je k dispozici vždy",
  "boiler.settings.temp_ek": "Teplota z FVE pomocí EK",
  "boiler.settings.temp_ek.subtitle": "Předehřívací teplota, která je pouze z přebytků",
  "boiler.settings.temp_spot": "Teplota ze spotu pomocí EK",
  "boiler.settings.temp_spot.subtitle": "Předehřívací teplota, která je pouze z nízké ceny",
  "boiler.statistics": "Výkon bojleru",
  "boiler.statisticsTemp": "Teplota bojleru",
  "boiler.status": "Režim Bojleru",
  "boiler.status.home": "Režim bojleru",
  "boiler_test_trigger.button": "Otestovat bojler",
  "boiler_test_trigger.button.running": "Test probíhá",
  "boiler_test_trigger.subtitle": "Ověří správné zapojení a zadaný výkon patrony bojleru.",
  "boiler_test_trigger.title": "Test bojleru",
  "boiler_test_wizard.acknowledge.condition": "Pro správný test bojleru je nutné, aby byla spotřeba v objektu konstantní a nebo nulová. Jakékoliv výkyvy ve spotřebě mohou test ovlivnit. Aktuální spotřeba objektu je {power}",
  "boiler_test_wizard.acknowledge.config": "Aktuálně je nastaven {phaseLabel} bojler o celkové výkonu {power}. Tyto hodnoty musí být zadané dle štítku patrony.",
  "boiler_test_wizard.acknowledge.confirm": "Potvrzuji",
  "boiler_test_wizard.acknowledge.phase1": "1-fázový",
  "boiler_test_wizard.acknowledge.phase3": "3-fázový",
  "boiler_test_wizard.acknowledge.phase_option": "{phase}. fáze",
  "boiler_test_wizard.acknowledge.phase_select": "Vyberte fáze, které se mají otestovat. Neoznačené fáze budou přeskočeny.",
  "boiler_test_wizard.acknowledge.phase_select_empty": "Vyberte alespoň jednu fázi.",
  "boiler_test_wizard.acknowledge.start": "Otestovat bojler",
  "boiler_test_wizard.acknowledge.title": "Informace k testu",
  "boiler_test_wizard.result.after": "Spotřeba objektu po aktivaci",
  "boiler_test_wizard.result.before": "Spotřeba objektu před aktivací",
  "boiler_test_wizard.result.close": "Zavřít",
  "boiler_test_wizard.result.correct": "Spotřeba bojleru korektní",
  "boiler_test_wizard.result.detail_toggle": "Detail testu",
  "boiler_test_wizard.result.header": "Výsledek testu:",
  "boiler_test_wizard.result.phase_header": "{phase}. fáze",
  "boiler_test_wizard.result.real_power": "Odhadovaný příkon bojleru",
  "boiler_test_wizard.result.rerun": "Spustit test znovu",
  "boiler_test_wizard.result.set_power": "Zadaný výkon",
  "boiler_test_wizard.result.stable": "Měření bylo stabilní",
  "boiler_test_wizard.result.title": "Výsledek testu",
  "boiler_test_wizard.running.activate": "Aktivace fáze bojleru",
  "boiler_test_wizard.running.after": "Spotřeba objektu je {power}",
  "boiler_test_wizard.running.before": "Spotřeba objektu před testem je {power}",
  "boiler_test_wizard.running.measuring": "Probíhá měření…",
  "boiler_test_wizard.running.phase": "Testuji fázi {phase}",
  "boiler_test_wizard.running.real_power": "Odhadovaný výkon bojleru je {power}",
  "boiler_test_wizard.running.remaining": "Zbývá přibližně {seconds} s",
  "boiler_test_wizard.running.reset": "Nulování spotřeby",
  "boiler_test_wizard.running.result_fail": "Test fáze není korektní",
  "boiler_test_wizard.running.result_ok": "Test fáze je korektní",
  "boiler_test_wizard.running.stable": "Spotřeba je stabilní",
  "boiler_test_wizard.running.title": "Probíhá test",
  "boiler_test_wizard.running.unstable": "Měření nebylo stabilní",
  "boiler_test_wizard.title": "Testování bojleru",
  "cancel": "Zrušit",
  "chart.range.this_week": "Poslední týden",
  "chart.range.today": "Posledních 24{nbsp}hodin",
  "chart.tooltip.active_condition.title": "Aktuální režim:",
  "chart.tooltip.active_condition.value.battery": "Baterie",
  "chart.tooltip.active_condition.value.compressor-blocked": "Blokace kompresoru, nízký stav baterie",
  "chart.tooltip.active_condition.value.cooling": "Chlazení",
  "chart.tooltip.active_condition.value.error": "Chyba",
  "chart.tooltip.active_condition.value.heating": "Vytápění",
  "chart.tooltip.active_condition.value.hot-water": "Ohřev teplé vody",
  "chart.tooltip.active_condition.value.inactive": "Neaktivní",
  "chart.tooltip.active_condition.value.manual": "Manualní",
  "chart.tooltip.active_condition.value.not-connected": "Nelze navázat spojení",
  "chart.tooltip.active_condition.value.not-licensed": "Není licencováno",
  "chart.tooltip.active_condition.value.off": "Vypnuto",
  "chart.tooltip.active_condition.value.overflow": "Přetok",
  "chart.tooltip.active_condition.value.pool": "Ohřev bazénu",
  "chart.tooltip.active_condition.value.spot": "Spot",
  "chart.tooltip.active_condition.value.time": "Časový",
  "chart.tooltip.control_mode.title": "Řízeno podle:",
  "chart.tooltip.control_mode.value": "{mode, select, photovoltaic {Fotovoltaika} grid {Distribuční síť} spot {Spot} flexibility {Flexibilita} error {Chyba} other {{mode}} }",
  "chart.tooltip.wallbox_authorization_card_id.title": "Autorizační karta:",
  "charts.error.dialog.title": "Při načítání statistik došlo k chybě",
  "charts.mode.day": "Den",
  "charts.mode.week": "Týden",
  "charts.mode.year": "Rok",
  "charts.summary.value": "Celkem {value}",
  "close": "Zavřít",
  "cloud_plugs.bat": "Řízení podle baterie",
  "cloud_plugs.battery.battery_start": "Zapnout při nabití",
  "cloud_plugs.battery.battery_start.subtitle": "Nabití baterie při kterém se aktivuje zásuvka",
  "cloud_plugs.battery.battery_stop": "Vypnout při nabití",
  "cloud_plugs.battery.battery_stop.subtitle": "Nabití baterie při kterém se vypne zásuvka",
  "cloud_plugs.battery.on": "Aktivní",
  "cloud_plugs.battery_charged": "Nabití baterie",
  "cloud_plugs.condition": "Podmínka",
  "cloud_plugs.condition.and": "A",
  "cloud_plugs.condition.or": "Nebo",
  "cloud_plugs.led_mode.battery.subtitle": "Podsvícení aktivní, pokud má baterie alespoň 95%",
  "cloud_plugs.led_mode.battery.switch.title": "Podsvícení při sepnuté zásuvce",
  "cloud_plugs.led_mode.battery.title": "Podsvícení při nabité baterii",
  "cloud_plugs.led_mode.mode": "{mode, select, unknown {---} off {Vypnuto} switch {} power {Podle příkonu} other {Neznámý}}",
  "cloud_plugs.led_mode.overflow.subtitle": "Podsvícení aktivní, pokud dojde ke stabilnímu přetoku",
  "cloud_plugs.led_mode.overflow.title": "Podsvícení při přetoku",
  "cloud_plugs.led_mode.switch.subtitle": "Podsvícení aktivní, pokud je zásuvka sepnutá",
  "cloud_plugs.led_mode.title": "LED signalizace",
  "cloud_plugs.list.id": "ID",
  "cloud_plugs.list.led_mode": "LED signalizace",
  "cloud_plugs.list.online": "Online",
  "cloud_plugs.list.relay": "Relé",
  "cloud_plugs.list.title": "Status",
  "cloud_plugs.overflow": "Řízení podle přetoku",
  "cloud_plugs.overflow.help": "Zapínání zásuvky při definovaném přetoku do distribuční sítě.",
  "cloud_plugs.overflow.on": "Aktivní",
  "cloud_plugs.overflow.startPower": "Zapnout při odběru ze sítě",
  "cloud_plugs.overflow.startPower.help": "Zásuvka se zapne, pokud je přetok v nastavené výši po definovaný interval zpoždění. Pokud je hodnota nastavena na - 1500W a zpoždění zapnutí je 5 minut, tak zásuvka sepne při přetoku do sítě ve výši alespoň 1500W po dobu 5 minut.",
  "cloud_plugs.overflow.startPower.subtitle": "Záporná hodnota je přetok, kladná hodnota je odběr",
  "cloud_plugs.overflow.stopPower": "Vypnout při odběru ze sítě",
  "cloud_plugs.overflow.stopPower.help": "Zásuvka se vypne, pokud je odběr vyšší než nastavený po definovaný interval zpoždění. Pokud je hodnota nastavena na 100W a zpoždění vypnutí je 5 minut, tak zásuvka vypne při odběru ze sítě ve výši minimálně 100W po dobu 5 minut.",
  "cloud_plugs.overflow.stopPower.subtitle": "Záporná hodnota je přetok, kladná hodnota je odběr",
  "cloud_plugs.pv_power": "Řízení podle výkonu FVE",
  "cloud_plugs.pv_power.help": "Zapínání zásuvky při definovaném výkonu FVE.",
  "cloud_plugs.pv_power.on": "Aktivní",
  "cloud_plugs.pv_power.startPower": "Zapnout při výrobě FVE",
  "cloud_plugs.pv_power.startPower.help": "Zásuvka se zapne, pokud je výkon FVE větší než nastavená hodnota. Pokud je hodnota nastavena na 1000W, tak se zásuvka sepne při výrobě FVE ve výši alespoň 1000W.",
  "cloud_plugs.pv_power.stopPower": "Vypnout při výrobě FVE",
  "cloud_plugs.pv_power.stopPower.help": "Zásuvka se vypne, pokud je výkon FVE menší než nastavená hodnota. Pokud je hodnota nastavena na 500W, tak se zásuvka vypne při výrobě FVE nižší než 500W.",
  "cloud_plugs.time": "Řízení podle času",
  "cloud_plugs.time.on": "Aktivní",
  "cloud_plugs.title": "Zásuvky",
  "cloud_plugs.turn_off": "Vypnout",
  "cloud_plugs.turn_on": "Zapnout",
  "dark_mode.dark": "Tmavý",
  "dark_mode.light": "Světlý",
  "dark_mode.system": "System",
  "delta_green.battery_max_power_in": "Maximální výkon baterie IN (W)",
  "delta_green.battery_max_power_out": "Maximální výkon baterie OUT (W)",
  "delta_green.business_flexibility.title": "Obchodní flexibilita",
  "delta_green.connected": "Stav",
  "delta_green.enabled": "Integrace zapnuta",
  "delta_green.last_messages": "Poslední zprávy",
  "delta_green.last_messages.date": "Čas",
  "delta_green.last_messages.payload": "Zpráva",
  "delta_green.last_messages.topic": "Topic",
  "delta_green.pv_orientation": "Orientace fotovoltaiky",
  "delta_green.title": "Delta Green",
  "des_battery_container.status.error": "Chyba",
  "des_battery_container.status.none": "Neznámý stav",
  "des_battery_container.status.off": "Vypnuto",
  "des_battery_container.status.run": "Běžný režim",
  "des_battery_container.status.sleep": "Režim spánku",
  "dev.cloud_plugs.mqtt_cloud.connected": "Stav MQTT Cloud připojení",
  "dev.cloud_plugs.title": "Cloudové zásuvky",
  "dev.inverter_config.connection.lan": "LAN",
  "dev.inverter_config.connection.rs485": "RS485",
  "dev.inverter_config.connection.rs485_hint": "Adresa a port se přebírají z desky ({host}:{port}).",
  "dev.inverter_config.rename_warning": "Přejmenování klíče z \"{from}\" na \"{to}\" osiřelí historická data — statistiky i načítanou vyrobenou energii, které jsou vedené pod původním klíčem.",
  "dev.inverter_config.search.open": "Vyhledat střídač",
  "dev.inverter_config.search.title": "Vyhledat střídač",
  "dev.inverter_config.stats.all": "Vše",
  "dev.inverter_config.status.counts": "OK {ok} / Chyb {err}",
  "dev.inverter_config.status.error": "Chyba",
  "dev.inverter_config.status.ok": "OK",
  "dev.inverter_config.status.starting": "Spouští se",
  "dev.inverter_config.title": "Konfigurace střídačů",
  "dev.link": "Dev",
  "dev_app_messages.test_send": "Testovací notifikace",
  "dev_app_messages.test_send.button": "Odeslat",
  "dev_homepage.app_messages.title": "Notifikace",
  "dev_homepage.title": "Vývojové menu",
  "dev_status_log.empty": "Zatím žádná data",
  "dev_status_log.error": "Chyba při načítání",
  "dev_status_log.title": "Status log",
  "dev_status_log.today": "Dnes",
  "dhcp_host.address": "IP adresa",
  "dhcp_host.create.title": "Nový DHCP host",
  "dhcp_host.edit.title": "Upravit DHCP host",
  "dhcp_host.mac": "MAC adresa",
  "dhcp_host.name": "Název",
  "dhcp_hosts.remove.cancel": "Zrušit",
  "dhcp_hosts.remove.confirm": "Smazat",
  "dhcp_hosts.remove.confirm.title": "Opravdu chcete odfixovat adresu DHCP hosta?",
  "dhcp_leases.ip": "IP adresa",
  "dhcp_leases.mac": "MAC adresa",
  "dhcp_leases.make_static.cancel": "Zrušit",
  "dhcp_leases.make_static.confirm": "Přidat",
  "dhcp_leases.make_static.confirm.title": "Opravdu chcete zafixovat adresu DHCP hosta?",
  "dhcp_leases.name": "Jméno",
  "dhcp_leases.next_renewal": "Další obnovení",
  "dhcp_leases.title": "DHCP Leases",
  "ean": "EAN",
  "electree.business_flexibility.title": "Obchodní flexibilita",
  "electree.connected": "Stav",
  "electree.enabled": "Integrace zapnuta",
  "electree.last_messages": "Poslední zprávy",
  "electree.last_messages.date": "Čas",
  "electree.last_messages.payload": "Zpráva",
  "electree.last_messages.topic": "Topic",
  "electree.title": "Electree",
  "electrical_grid.common": "Obecné informace",
  "electrical_grid.common.overflow": "Celkový přetok do sítě",
  "electrical_grid.common.overflow_today": "Dnešní přetok do sítě:",
  "electrical_grid.common.overflow_year": "Roční přetok do sítě:",
  "electrical_grid.common.power": "Aktuální odběr",
  "electrical_grid.common.power.phase_1": "Fáze 1:",
  "electrical_grid.common.power.phase_2": "Fáze 2:",
  "electrical_grid.common.power.phase_3": "Fáze 3:",
  "electrical_grid.common.power_today": "Dnešní odběr ze sítě:",
  "electrical_grid.common.power_year": "Roční odběr ze sítě:",
  "electrical_grid.common.total_consumption": "Celkový odběr ze sítě",
  "electrical_grid.statistics": "Statistiky nákupu",
  "electrical_grid.statistics_overflow": "Statistiky přetoku",
  "electrical_grid.status": "Stav distribuční sítě",
  "ems.activePower": "Činný výkon",
  "ems.apparentPower": "Zdánlivý výkon",
  "ems.details": "Parametry měniče",
  "ems.inverter": "Měnič",
  "ems.inverter.mode.backup": "Backup",
  "ems.inverter.mode.feedIn": "Feed-in",
  "ems.inverter.mode.manual": "Manual",
  "ems.inverter.mode.peakShaving": "Peak Shaving",
  "ems.inverter.mode.selfUse": "Self use",
  "ems.inverter.name": "Název střídače",
  "ems.inverter.name.aelio": "X3-AELIO",
  "ems.inverter.name.notConnected": "Nepřipojeno",
  "ems.inverter.name.trene100k": "X3-TRENE-100K",
  "ems.inverter.name.trene100ki": "X3-TRENE-100KI",
  "ems.inverter.name.trene125k": "X3-TRENE-125K",
  "ems.inverter.name.unknown": "Neznámý model",
  "ems.mode": "Režim EMS",
  "ems.power.index": "Výkon string {index}",
  "ems.power.total": "Celkový výkon",
  "ems.powerFactor": "Účiník",
  "ems.reactivePower": "Jalový výkon",
  "emsPro.inverter.name.aelio": "X3-AELIO",
  "emsPro.inverter.name.notConnected": "Nepřipojeno",
  "emsPro.inverter.name.trene1": "X3-TRENE-1",
  "emsPro.inverter.name.trene100k": "X3-TRENE-100K",
  "emsPro.inverter.name.trene125k": "X3-TRENE-125K",
  "emsPro.inverter.name.x3forth": "X3-FORTH",
  "emsPro.inverter.name.x3forthplus": "X3-FORTH+",
  "emsPro.inverter.name.x3grand": "X3-GRAND",
  "emsPro.inverter.name.x3mgag2": "X3-MGA G2",
  "emsPro.inverter.name.x3prog2": "X3-PRO G2",
  "emsService.basicSettings": "Komunikace s RTU",
  "emsService.direction.disabled": "Zakázáno",
  "emsService.direction.read": "Čtení",
  "emsService.direction.write": "Zápis",
  "emsService.distributionMetrics": "Distribuční pokyny",
  "emsService.distributionMetrics.diMapping": "Mapování vstupů",
  "emsService.distributionMetrics.enabled": "Povoleno čtení distribučních pokynů",
  "emsService.distributionMetrics.source": "Zdroj distribučních pokynů",
  "emsService.distributionMetrics.source.digitalInputs": "Digitální vstupy",
  "emsService.distributionMetrics.source.plc": "Externí PLC",
  "emsService.enabled": "PLC Povoleno",
  "emsService.energyMeters": "Elektroměry (Shelly EM / PLC)",
  "emsService.energyMeters.add": "Přidat nový elektroměr",
  "emsService.energyMeters.addButton": "Přidat",
  "emsService.energyMeters.azRouter": "AZ router",
  "emsService.energyMeters.azRouter.empty": "Žádné AZ routery",
  "emsService.energyMeters.empty": "Nejsou nakonfigurovány žádné elektroměry",
  "emsService.energyMeters.newMeter": "Název",
  "emsService.energyMeters.plcMetric": "PLC Metrika",
  "emsService.energyMeters.plcMetric.grid": "Grid",
  "emsService.energyMeters.plcMetric.kgj": "KGJ",
  "emsService.energyMeters.plcMetric.pv": "FVE",
  "emsService.energyMeters.shellyId": "Shelly ID",
  "emsService.energyMeters.source": "Zdroj",
  "emsService.energyMeters.source.azRouter": "AZ router",
  "emsService.energyMeters.source.plc": "PLC",
  "emsService.energyMeters.source.shelly": "Shelly",
  "emsService.gridMetrics.enabled": "Povoleno čtení paty objektu",
  "emsService.ipAddress": "IP Adresa",
  "emsService.kgjMetrics.enabled": "Povoleno čtení z KGJ",
  "emsService.metricsDirection": "Směr",
  "emsService.mqttBroker": "MQTT Broker (Shellies)",
  "emsService.mqttBrokerEnabled": "MQTT Broker povolen",
  "emsService.mqttBrokerStatus": "Stav MQTT Brokeru",
  "emsService.notAvailable": "Funkce EMS není k dispozici",
  "emsService.password": "Heslo",
  "emsService.plcStatus": "Stav PLC komunikace",
  "emsService.pollInterval": "Interval dotazování (ms)",
  "emsService.pvMetrics.enabled": "Povoleno čtení z FVE",
  "emsService.shelliesList": "Připojená Shelly zařízení",
  "emsService.username": "Uživatelské jméno",
  "ems_service.link": "EMS Service",
  "ems_service.title": "EMS Service",
  "enerco.ean": "EAN",
  "enerco.enabled": "Integrace zapnuta",
  "enerco.prediction.disabled": "Integrace je vypnutá.",
  "enerco.prediction.title": "Predikce",
  "enerco.title": "Enerco",
  "energomachine.business_flexibility.title": "Obchodní flexibilita",
  "energomachine.connected": "Stav",
  "energomachine.enabled": "Integrace zapnuta",
  "energomachine.last_messages": "Poslední zprávy",
  "energomachine.last_messages.date": "Čas",
  "energomachine.last_messages.payload": "Zpráva",
  "energomachine.last_messages.topic": "Topic",
  "energomachine.title": "Energomachine",
  "energyMeters.actualPower": "Aktuální výkon",
  "energyMeters.general": "Obecné informace",
  "energyMeters.meter": "Elektroměr",
  "energyMeters.notConfigured": "Elektroměry nejsou nakonfigurovány. Pro nastavení přejděte do servisního menu.",
  "energyMeters.phase1": "Fáze 1:",
  "energyMeters.phase2": "Fáze 2:",
  "energyMeters.phase3": "Fáze 3:",
  "energyMeters.statistics": "Statistiky",
  "energyMeters.todayEnergy": "Dnešní spotřeba:",
  "energyMeters.totalEnergy": "Celková spotřeba",
  "energyMeters.yearEnergy": "Roční spotřeba:",
  "error": "Chyba při načítání reportu.",
  "expertService.HP": "Tepelné čerpadlo",
  "expertService.HP.CntComErr": "Čítač chybných zpráv",
  "expertService.HP.CntComOk": "Čítač validních zpráv",
  "expertService.HP.IpAdr": "IP adresa tepelného čerpadla",
  "expertService.HP.maxTempHW": "Maximální teplota teplé vody pro TČ",
  "expertService.HP.maxTempHW.subtitle": "Součet flexibilní + nastavené teploty",
  "expertService.HW": "Bojler",
  "expertService.HW.HwBatteryPriority": "Procento nabítí od kterého má vždy prioritu bojler",
  "expertService.HW.HwErrEnabled": "Vyhodnocovat dostupnost bojleru",
  "expertService.HW.HwResetErrorTime": "Prodleva pro reset chyby termostatu",
  "expertService.HW.HwResetErrorTime.subtitle": "Čas v minutách po kterém se chyba termostatu resetuje a opět se spustí ohřev vody",
  "expertService.HW.LegionellaLastTime": "Poslední dosažení teploty legionelly",
  "expertService.HW.TempId": "ID teplotního čidla",
  "expertService.HW.control": "Typ řízení bojleru",
  "expertService.HW.control.onoff": "On/Off",
  "expertService.HW.control.proportional": "Plynulé",
  "expertService.HW.hysterezis": "Hystereze bojleru",
  "expertService.HW.hysterezis.subtitle": "Hystereze je pouze pro běžný ohřev",
  "expertService.HW.maxPower": "Maximální výkon bojleru v procentech",
  "expertService.HW.maxPower.subtitle": "Toto nastavení je pouze pro plynulé řízení bojleru a omezuje maximální výkon patrony v procentech.",
  "expertService.HW.offset": "Offset na fázi [W]",
  "expertService.HW.offset.disabled-overflow": "Offset pro řízení bojleru se zakázaným přetokem na fázi [W]",
  "expertService.HW.offset.disabled-overflow.subtitle": "Vyšší číslo umožní bojleru odebírat více energie ze sítě při omezeném střídači",
  "expertService.HW.offset.enabled-overflow": "Offset pro řízení bojleru s povoleným přetokem na fázi [W]",
  "expertService.HW.offset.enabled-overflow.subtitle": "Vyšší číslo umožní bojleru odebírat více energie ze sítě.",
  "expertService.HW.offset.ongrid": "Offset pro řízení bojleru pro síťové elektrárny [W]",
  "expertService.HW.offset.ongrid.subtitle": "Vyšší číslo umožní bojleru odebírat více energie ze sítě.",
  "expertService.PV": "Fotovoltaika",
  "expertService.PV.BatteryPowerPercent": "Výkon nabíjení baterie v procentech",
  "expertService.PV.CntComErr": "Čítač chybných zpráv",
  "expertService.PV.CntComOk": "Čítač validních zpráv",
  "expertService.PV.ControlMeteringMode": "Způsob řízení přebytků",
  "expertService.PV.ControlMeteringMode.perPhase": "Fázové",
  "expertService.PV.ControlMeteringMode.subtitle": "Fázové řízení počítá přebytek pro řízení technologií z jednotlivých fází. Součtové řízení pracuje se součtem všech fází.",
  "expertService.PV.ControlMeteringMode.sum": "Součtové",
  "expertService.PV.ExternalPv": "Externí FVE připojená skrze SOLAX Meter 2",
  "expertService.PV.ExternalPvSofar": "Externí FVE připojená skrze SOFAR Meter 2",
  "expertService.PV.IpAdr": "IP adresa střídače",
  "expertService.PV.MeteringMode": "Způsob měření distribuce",
  "expertService.PV.MeteringMode.perPhase": "Fázové",
  "expertService.PV.MeteringMode.subtitle": "Fázové měření (ČR) počítá nákup i přetok na každé fázi zvlášť. Součtové měření pracuje s výslednou bilancí všech fází.",
  "expertService.PV.MeteringMode.sum": "Součtové",
  "expertService.PV.PowerControlType": "Typ řízení výkonu síťových střídačů",
  "expertService.PV.PowerControlType.fixed": "Fixní",
  "expertService.PV.PowerControlType.proportional": "Plynulé",
  "expertService.PV.StringNumber": "Počet stingů střídače",
  "expertService.PV.StringNumber.subtitle": "Počet stingů střídače zobrazovaný v aplikaci na záložce FVE",
  "expertService.PV.Versions": "Verze",
  "expertService.SP": "Spot",
  "expertService.SP.HwCoefficient": "Koeficiet odhadu energie do bojleru",
  "expertService.SP.HwCoefficient.subtitle": "Koeficient odhadu množství energie pro nabití bojleru.",
  "expertService.SP.batteryCoefficient": "Koeficiet odhadu času nabíjení baterie",
  "expertService.SP.batteryCoefficient.subtitle": "Koeficient odhadu času pro nabíjení a vybíjení baterie",
  "expertService.SP.minDifferenceBatterychargeFromGrid": "Minimální odhadované zvýšení SOC pro vyčkání baterie na FVE",
  "expertService.SP.minDifferenceBatterychargeFromGrid.subtitle": "Pokud je odhad nabití baterie pod touto hodnotou, může dojít k nabití baterie ze sítě.",
  "expertService.WB": "Wallbox",
  "expertService.WB.CntComErr": "Čítač chybných zpráv",
  "expertService.WB.CntComOk": "Čítač validních zpráv",
  "expertService.WB.IpAdr": "IP adresa wallboxu",
  "expertService.general": "Obecné nastavení",
  "expertService.general.largeInstallation": "Velká instalace",
  "expertService.general.largeInstallation.subtitle": "Rozšíří rozsahy hodnot pro velké instalace",
  "expertService.password": "Přístup do servisu",
  "expertService.password.label": "Heslo",
  "expert_service.app_messages": "Zprávy",
  "expert_service.audit_log": "Audit log",
  "expert_service.error_list": "Seznam chyb",
  "expert_service.link": "Expert Service",
  "expert_service.network": "Síť",
  "expert_service.network.button": "Přejít do nastavení sítě",
  "expert_service.network.link": "Siť",
  "expert_service.reports": "Reporty",
  "expert_service.stats": "Statistiky",
  "expert_service.title": "Service",
  "expert_service.xyz": "Servis",
  "header.title": "Domovská stránka",
  "header.title.app_messages": "Zprávy",
  "header.title.audit_log": "Audit Log",
  "header.title.boiler": "Bojler",
  "header.title.cloud_plugs": "Zásuvky",
  "header.title.dev": "Nastavení sítě",
  "header.title.dev.app_messages": "Notifikace",
  "header.title.dev.az_routers": "AZ routery",
  "header.title.dev.bez_dodavatele": "bezDodavatele",
  "header.title.dev.cloud_plugs": "Cloudové zásuvky",
  "header.title.dev.delta_green": "Delta Green",
  "header.title.dev.electree": "Electree",
  "header.title.dev.enerco": "Enerco",
  "header.title.dev.energomachine": "Energomachine",
  "header.title.dev.inverter_config": "Konfigurace střídačů",
  "header.title.dev.mqtt_broker": "MQTT Broker",
  "header.title.dev.mqtt_cloud": "MQTT Cloud",
  "header.title.dev.pre_flexibility": "PRE Flexibilita",
  "header.title.dev.scripts": "Scripty",
  "header.title.dev.shellies": "Shellies",
  "header.title.dev.status_log": "Status log",
  "header.title.dev.subscriptions": "Předplatné",
  "header.title.dev_homepage": "Vývojové menu",
  "header.title.ems": "EMS",
  "header.title.ems_service": "EMS Service",
  "header.title.energyMeters": "Elektroměry",
  "header.title.expert_service": "Expert Service",
  "header.title.expert_service.network": "Nastavení sítě",
  "header.title.grid": "Distribuční síť",
  "header.title.heat_pump": "Tepelné čerpadlo",
  "header.title.photovoltaics": "Fotovoltaika",
  "header.title.plug": "Zásuvka",
  "header.title.relay": "Relé",
  "header.title.reports": "Reporty",
  "header.title.rfid_cards": "RFID karty",
  "header.title.settings": "Nastavení",
  "header.title.spot": "Spot",
  "header.title.statistics": "Statistiky",
  "header.title.thermostat": "Termostat",
  "header.title.wallbox": "Wallbox",
  "header.title.wallbox_list": "Wallboxy",
  "header.title.wind": "Větrná elektrárna",
  "heat_pump.HW": "Ohřev teplé vody",
  "heat_pump.HW.actual_temp": "Aktuální teplota nádrže",
  "heat_pump.HW.flexitemp": "Flexibilní teplota",
  "heat_pump.HW.flexitemp.subtitle": "Teplota o kterou je možné předehřát teplou vodu",
  "heat_pump.HW.hysteresis": "Hystereze ohřevu teplé vody",
  "heat_pump.HW.on": "Ohřev teplé vody",
  "heat_pump.HW.temp": "Požadovaná teplota nádrže",
  "heat_pump.acond": "Acond",
  "heat_pump.blocked": "Blokace kompresoru",
  "heat_pump.blocked.min_soc": "Blokace kompresoru při nedostupné síti",
  "heat_pump.blocked.min_soc_utility": "Blokace kompresoru při dostupné síti",
  "heat_pump.blocked.subtitle": "Nabití baterie, od kterého dojde k blokaci kompresoru při dostupné síti",
  "heat_pump.common": "Obecné informace",
  "heat_pump.common.power": "Aktuální odběr",
  "heat_pump.common.power_today": "Dnešní spotřeba:",
  "heat_pump.common.power_year": "Roční spotřeba:",
  "heat_pump.common.temp": "Výstupní teplota tepelného čerpadla",
  "heat_pump.common.total": "Celková spotřeba",
  "heat_pump.ecoone": "Ecoone",
  "heat_pump.flexi": "Flexibilita energie",
  "heat_pump.flexi.flexi_on": "Režim flexibility",
  "heat_pump.flexi.flexi_on.subtitle": "Režim aktivuje předehřev z přebytkové energie",
  "heat_pump.flexi.pvstability": "Potenciál aktivace kompresoru",
  "heat_pump.flexi_sp": "Flexibilita spot",
  "heat_pump.flexi_sp.flexi_increase_on": "Zvýšení spotřeby",
  "heat_pump.flexi_sp.flexi_increase_on.subtitle": "Režim umožní zvýšení spotřeby při nízké ceně energie",
  "heat_pump.flexi_sp.flexi_reduce_on": "Odložení spotřeby",
  "heat_pump.flexi_sp.flexi_reduce_on.subtitle": "Režim umožní odložení spotřeby při vysoké ceně energie",
  "heat_pump.nibe": "Nibe",
  "heat_pump.room": "Vytápění",
  "heat_pump.room.equithermalCorrection": "Posun topné křivky",
  "heat_pump.room.flexitemp": "Flexibilní teplota",
  "heat_pump.room.flexitemp.subtitle": "Teplota o kterou je možné předehřát nebo předchladit dům",
  "heat_pump.room.on": "Vytápění",
  "heat_pump.room.tem": "Požadovaná teplota",
  "heat_pump.room.temp": "Aktuální teplota místnosti",
  "heat_pump.room.tempmax": "Požadovaná teplota komfort",
  "heat_pump.room.tempmin": "Požadovaná teplota útlum",
  "heat_pump.room_cool.on": "Chlazení",
  "heat_pump.status": "Režim tepelka",
  "heat_pump_wizard.cancel": "Zrušit",
  "heat_pump_wizard.ip_address.alert": "Ujistěte se prosím, že se IP adresa tepelného čerpadla nebude měnit (např. když TČ využívá adresu z DHCP).",
  "heat_pump_wizard.ip_address.input": "IP adresa tepelného čerpadla",
  "heat_pump_wizard.open": "Nastavit typ TČ",
  "heat_pump_wizard.save": "Uložit",
  "heat_pump_wizard.title": "Nastavení tepelného čerpadla",
  "heatpump.statistics": "Statistiky",
  "heatpump.status": "Režim tepelka",
  "homepage.actual.battery": "Stav baterie",
  "homepage.actual.boiler": "Bojler",
  "homepage.actual.outdoor_temperature": "Venkovní teplota",
  "homepage.actual.thermostat": "Termostat",
  "homepage.actual.title": "",
  "homepage.animation": "Aktuálně",
  "homepage.statuses.title": "Režimy aktivních komponentů",
  "homepage.statuses.tooltip": "Režimy aktivních komponentů",
  "homepage.today.consumed": "Spotřeba domu",
  "homepage.today.consumed_WB": "Wallbox",
  "homepage.today.consumed_from_grid": "Spotřeba ze sítě",
  "homepage.today.consumed_hp": "Tepelné čerpadlo",
  "homepage.today.consumed_hw": "Teplá voda",
  "homepage.today.overflow": "Přetok do sítě",
  "homepage.today.photovoltaics": "Výroba FVE",
  "homepage.today.title": "Denní statistika",
  "homepage.today.wind": "Výroba větrné elektrárny",
  "hp.status.compressor_blocked": "Blokace kompresoru, nízký stav baterie",
  "hp.status.cooling": "Chlazení",
  "hp.status.heating": "Vytápění",
  "hp.status.hot_water": "Ohřev teplé vody",
  "hp.status.inactive": "Neaktivní",
  "hp.status.not_connected": "Nelze navázat spojení",
  "hp.status.not_licensed": "Tepelné čerpadlo není licencované",
  "hp.status.pool": "Ohřev bazénu",
  "hp.sub_status.consumption_postpone": "při snížení spotřeby",
  "hp.sub_status.consumption_rise": "při zvýšení spotřeby",
  "hp.sub_status.consumption_with_flexibility": "s flexibilitou",
  "hp.sub_status.nibe_not_writable": "- do NIBE nelze zapisovat",
  "hp.sub_status.none": "",
  "initial_wizard.banner.button": "Spustit průvodce",
  "initial_wizard.banner.hide.confirm": "Opravdu chcete skrýt průvodce?",
  "initial_wizard.banner.hide.confirm.description": "Průvodce můžete kdykoli znovu spustit v nastavení aplikace.",
  "initial_wizard.banner.hide.show_more": "Spustit průvodce",
  "initial_wizard.banner.hide.yes": "Skrýt",
  "initial_wizard.banner.subtitle": "Průvodce vám pomůže nastavit základní parametry vašeho systému.",
  "initial_wizard.banner.title": "Dokončete počáteční nastavení",
  "initial_wizard.banner.title.completed": "Projít počáteční nastavení",
  "initial_wizard.dialog.finish": "Dokončit",
  "initial_wizard.dialog.next": "Další",
  "initial_wizard.dialog.prev": "Zpět",
  "initial_wizard.dialog.step": "Krok {current} z {total}",
  "initial_wizard.dialog.title": "Průvodce počátečním nastavením",
  "initial_wizard.step1.description.active": "Váš přístup do servisu je již aktivní. Můžete pokračovat na další krok.",
  "initial_wizard.step1.password_info": "Každá firma má vlastní přístupové heslo do servisního menu. Heslo jste obdrželi v emailové komunikaci. Můžete si jej také kdykoliv zobrazit v app.infigy.cz v partnerské sekci.",
  "initial_wizard.step1.title": "Přístup do servisu",
  "initial_wizard.step1.welcome": "Vítejte v úvodním nastavení Infigy. Provedeme vás základní konfigurací vašeho systému. Detailnější nastavení poté najdete v servisním menu.",
  "initial_wizard.step10.title": "Nastavení wallboxu",
  "initial_wizard.step11.description": "Prošli jste základní nastavení Infigy. Veškeré parametry lze upravit v servisním menu.",
  "initial_wizard.step11.service_menu.subtitle": "Nastavení -> úplně dolů -> Přístup do servisu",
  "initial_wizard.step11.service_menu.title": "Servisní menu",
  "initial_wizard.step11.title": "Hotovo",
  "initial_wizard.step2.title": "Aktualizace aplikace",
  "initial_wizard.step3.title": "Instalace",
  "initial_wizard.step4.title": "Nastavení hlavního jističe",
  "initial_wizard.step5.title": "Připojení střídače",
  "initial_wizard.step6.title": "Parametry střídače",
  "initial_wizard.step7.description": "Pokud je omezen přetok do sítě, dojde k přenesení nastavení do střídače. Omezování přetoků zajištuje střídač. Zápis a změnu hodnoty však řídí Infigy dle zadané hodnoty v tomto poli. Neupravujte tedy omezení přetoku ve střídači. Při prvním nastavení si zapsanou hodnotu zkontrolujte ve střídači, zda se Vám správně promítla z Infigy do střídače.",
  "initial_wizard.step7.title": "Omezení přetoku",
  "initial_wizard.step8.title": "Nastavení bojleru",
  "initial_wizard.step9.title": "Nastavení spotového obchodování",
  "initial_wizard.step_app_update.description": "V čase kdy bylo Infigy na cestě k vám jsme mohli vydat nové verze aplikace. Doporučujeme před nastavením jednotku aktualizovat. Pokud ale například není dostupný internet, můžete aktualizaci přeskočit a provést ji později v servisním menu, nebo v portálu.",
  "inverter.3mar_plc": "3Mar PLC",
  "inverter.az_router": "AzRouter elektroměr",
  "inverter.des_battery_container": "DES - kontejnerové úložiště",
  "inverter.deye": "Deye LV",
  "inverter.deye_hv": "Deye HV",
  "inverter.fronius": "Fronius SYMO GEN24",
  "inverter.fronius_grid": "Fronius SYMO síťový",
  "inverter.fronius_verto": "Fronius Verto",
  "inverter.good_we": "GoodWe",
  "inverter.good_we_grid_next": "GoodWe síťový",
  "inverter.good_we_next": "GoodWe",
  "inverter.goodwe_grid": "Goodwe síťový",
  "inverter.hes": "HES - bateriové úložiště",
  "inverter.next": "Více střídačů",
  "inverter.none": "Žádný",
  "inverter.sermatec": "Sermatec",
  "inverter.shellies": "Shellies",
  "inverter.shellies_external": "Shellies External",
  "inverter.sma_grid": "SMA síťový",
  "inverter.sofar_solar": "Sofarsolar",
  "inverter.sofar_solar_rs485": "SofarSolar RS485",
  "inverter.solar_edge_grid": "SolarEdge síťový",
  "inverter.solax": "Solax",
  "inverter.solax_ems1000": "Solax EMS1000",
  "inverter.solax_ems1000pro": "Solax EMS1000PRO",
  "inverter.solax_grid": "Solax síťový",
  "inverter.solax_mega_grid": "Solax MEGA/FORTH síťový",
  "inverter.solax_mic_grid": "Solax MIC síťový",
  "inverter.solax_next": "SolaxNext",
  "inverter.solinteg": "Solinteg",
  "inverter.victron": "Victron",
  "inverter.wattsonic": "Wattsonic",
  "inverter_wizard.cancel": "Zrušit",
  "inverter_wizard.custom_device_ip_address.alert": "Ujistěte se prosím, že se IP adresa střídače nebude měnit (např. když střídač využívá adresu z DHCP).",
  "inverter_wizard.custom_device_ip_address.input": "IP adresa střídače",
  "inverter_wizard.multiple_inverters.alert": "Pro nastavení více střídačů prosím kontaktujte linku podpory. Kontakt najdete v technické wiki Infigy.",
  "inverter_wizard.multiple_inverters.label": "Více střídačů",
  "inverter_wizard.multiple_inverters_or_ems.alert": "Váš systém již obsahuje nastavení pro více střídačů nebo EMS. Tento průvodce je určen pouze pro nastavení jednoho střídače. Pro změnu nastavení střídačů nebo EMS prosím kontaktujte podporu.",
  "inverter_wizard.nominal_power": "Nominální výkon střídače",
  "inverter_wizard.nominal_power.helper": "Rozsah: 1 až 100 kW",
  "inverter_wizard.nominal_power.validation": "Zadejte nominální výkon střídače v kW.",
  "inverter_wizard.open": "Najít střídač",
  "inverter_wizard.save": "Uložit",
  "inverter_wizard.scan": "Najít střídač na síti",
  "inverter_wizard.scanning": "Hledám střídač na síti",
  "inverter_wizard.submit_error": "Nastala chyba při ukládání nastavení střídače. Zkuste to prosím znovu.",
  "inverter_wizard.title": "Průvodce připojením střídače",
  "layout.disconnected": "Odpojeno",
  "layout.pigpio_init_error_dialog.description": "Aplikace Infigy na zařízení nenaběhla správně. Zkuste prosím zařízení restartovat a pokud problém přetrvává, kontaktujte podporu.",
  "layout.pigpio_init_error_dialog.title": "Chyba při spuštění aplikace",
  "level.thermostat.cooling": "Chlazení",
  "level.thermostat.deactivated": "Neaktivní",
  "level.thermostat.heating": "Vytápění",
  "level.thermostat.standby": "Standby",
  "level.thermostat.tempErr": "Chyba Teploty",
  "level.thermostatFlexibility.increasePv": "Flexibilita využita pro zvýšení teploty dle fotovoltaiky",
  "level.thermostatFlexibility.increaseSpot": "Flexibilita využita pro zvýšení teploty dle SPOTU",
  "level.thermostatFlexibility.normal": "Normální",
  "level.thermostatFlexibility.reductionSpot": "Flexibilita využita pro snížení teploty dle SPOTU",
  "mqtt_broker.connected_clients.title": "Clients",
  "mqtt_broker.enabled": "Zapnuto",
  "mqtt_broker.running": "Stav",
  "mqtt_broker.title": "MQTT Broker",
  "mqtt_cloud.connected": "Stav",
  "mqtt_cloud.connected.offline": "Offline",
  "mqtt_cloud.connected.online": "Online",
  "mqtt_cloud.enabled": "Integrace zapnuta",
  "mqtt_cloud.title": "MQTT Cloud",
  "nav.app_messages": "Zprávy",
  "nav.home": "Domů",
  "nav.logout": "Odhlásit se",
  "nav.reports": "Reporty",
  "nav.sec.boiler": "Bojler",
  "nav.sec.cloud_plugs": "Zásuvky",
  "nav.sec.ems": "EMS",
  "nav.sec.energyMeters": "Elektroměry",
  "nav.sec.grid": "Síť",
  "nav.sec.heatpump": "Tepelné čerpadlo",
  "nav.sec.home": "Obecné",
  "nav.sec.photovoltaics": "Fotovoltaika",
  "nav.sec.plug": "Zásuvka",
  "nav.sec.relay": "Relé",
  "nav.sec.spot": "Spot",
  "nav.sec.thermostat": "Termostat",
  "nav.sec.wallbox": "Wallbox",
  "nav.sec.wind": "Větrná elektrárna",
  "nav.settings": "Nastavení",
  "nav.statistics": "Statistiky",
  "network.ethernet_ports": "Ethernet porty",
  "network.ethernet_ports.name": "LAN",
  "network.ethernet_ports.status": "Status",
  "network.ethernet_ports.status.down": "Neaktivní",
  "network.ethernet_ports.status.up": "Aktivní",
  "network.scan.error": "Skenování sítě se nezdařilo",
  "network.summary.address": "IP adresa",
  "network.summary.dhcp_host_exists": "Adresa zafixována na DHCP. Kliknutím odfixovat.",
  "network.summary.error": "Chyba při načítání",
  "network.summary.heat_pump": "Tepelné čerpadlo",
  "network.summary.inverter": "Střídač",
  "network.summary.mac": "MAC",
  "network.summary.name": "Jméno",
  "network.summary.no_dhcp_host": "Dynamická adresa na DHCP. Kliknutím zafixovat.",
  "network.summary.not_connected": "Není připojeno",
  "network.title": "Obecné",
  "network.wan_address": "WAN adresa",
  "network_wan_edit.dialog.address": "IP adresa",
  "network_wan_edit.dialog.close": "Zavřít",
  "network_wan_edit.dialog.dns": "DNS server",
  "network_wan_edit.dialog.gateway": "Výchozí brána",
  "network_wan_edit.dialog.netmask": "Maska sítě",
  "network_wan_edit.dialog.save": "Uložit",
  "network_wan_edit.dialog.title": "Editace WAN adresy",
  "nmap.empty": "Nic nenalezeno",
  "nmap.error": "Sken se nezdařil",
  "nmap.loading": "Skenuji",
  "nmap.output": "Výstup",
  "nmap.port": "Port",
  "nmap.port.help": "Prázdné = jen hledání zařízení",
  "nmap.range.external": "external — síť zákazníka",
  "nmap.range.internal": "internal — interní síť Infigy",
  "nmap.result.address": "IP adresa",
  "nmap.result.mac": "MAC adresa",
  "nmap.result.ports": "Porty",
  "nmap.result.scanning": "Skenuji {target}, může to chvíli trvat…",
  "nmap.result.target": "Skenovaný rozsah: {target}",
  "nmap.result.vendor": "Výrobce",
  "nmap.start": "Spustit",
  "nmap.target": "Adresa nebo rozsah",
  "nmap.target.help": "Pojmenovaná síť nebo IP / rozsah",
  "nmap.title": "Sken portů",
  "photovoltaics.battery": "Baterie",
  "photovoltaics.battery.battery_charged": "Nabití baterie",
  "photovoltaics.battery.battery_manual_discharge": "Manuálně vybít baterii",
  "photovoltaics.battery.battery_power": "Výkon baterie",
  "photovoltaics.battery.soc_actual": "Vypočtené minimální nabití",
  "photovoltaics.batteryStatus": "Stav BMS",
  "photovoltaics.battery_stop": "Blokace baterie",
  "photovoltaics.battery_stop.hdo": "Vybíjet baterii pouze při nízkém tarifu (HDO)",
  "photovoltaics.battery_stop.hp": "Blokovat baterii při provozu tepelného čerpadla",
  "photovoltaics.battery_stop.hw": "Blokovat baterii při provozu ohřevu vody",
  "photovoltaics.battery_stop.wb": "Blokovat baterii při provozu wallboxu",
  "photovoltaics.battery_stop.wb.lock_desc": "Při zapnutém režimu nabíjení wallboxu „Nabíjení podle baterie“ nebo „Přednostní nabíjení podle baterie“ nelze tuto blokaci zapnout. Pro zapnutí blokace nastavte jiný režim nabíjení wallboxu.",
  "photovoltaics.battery_stop.wb.lock_title": "Nastavení nelze změnit",
  "photovoltaics.common": "Obecné informace",
  "photovoltaics.common.battery_manual_charge": "Manuálně nabít baterii",
  "photovoltaics.common.battery_manual_charge_soc": "Cílové SOC pro manuální nabíjení",
  "photovoltaics.common.battery_manual_charge_subtitle": "Manuální nabíjení baterie nabije baterii na cílovou úroveň nabití pokud nedojde k dřívějšímu vypnutí uživatelem.",
  "photovoltaics.common.battery_manual_discharge_subtitle": "Manuální vybíjení baterie vybije baterii na minimální úroveň nabití pokud nedojde k dřívějšímu vypnutí uživatelem.",
  "photovoltaics.common.power": "Aktuální výkon",
  "photovoltaics.common.power_today": "Dnešní výroba:",
  "photovoltaics.common.power_total": "Celková výroba",
  "photovoltaics.common.power_year": "Roční výroba:",
  "photovoltaics.common.string1": "String 1:",
  "photovoltaics.common.string2": "String 2:",
  "photovoltaics.common.string3": "String 3:",
  "photovoltaics.common.string4": "String 4:",
  "photovoltaics.common.string5": "String 5:",
  "photovoltaics.common.string6": "String 6:",
  "photovoltaics.statistics": "Výkon elektrárny",
  "photovoltaics.statistics.charge": "Nabíjení baterie",
  "photovoltaics.statistics.discharge": "Vybíjení baterie",
  "photovoltaics.statisticsSoc": "Úroveň nabití baterie",
  "photovoltaics.status": "Režim FVE",
  "ping.address": "Adresa",
  "ping.output": "Výstup",
  "ping.start": "Spustit",
  "ping.stop": "Zastavit",
  "ping.title": "Ping",
  "plug.bat": "Řízení podle baterie",
  "plug.bat.batterySart": "Zapnout při nabití",
  "plug.bat.batterySart.help": "Úroveň nabití baterie, při kterém se zásuvka zapne. Aby k zapnutí došlo, musí dojít k přechodu nabití baterie z nastaveného stavu na vyšší stav. Pokud je hodnota nastavena na 80%, tak zásuvka sepne při nabití baterie ze 80% na 81%.",
  "plug.bat.batterySart.subtitle": "Nabití baterie při kterém se aktivuje zásuvka",
  "plug.bat.batteryStop": "Vypnout při nabití",
  "plug.bat.batteryStop.help": "Úroveň nabití baterie, při kterém se zásuvka vypne. Aby k vypnutí došlo, musí dojít k přechodu nabití baterie z nastaveného na nižší stav. Pokud je hodnota nastavena na 80%, tak zásuvka vypne při vybití baterie ze 80% na 79%.",
  "plug.bat.batteryStop.subtitle": "Nabití baterie při kterém se vypne zásuvka",
  "plug.bat.help": "Spínání při definované úrovni nabití baterie. Lze kombinovat s podmínkou času. Při kombinaci podmínek se zásuvka zapne, pokud je splněna alespoň jedna z podmínek pro zapnutí a vypne, pokud je splněna alespoň jedna z podmínek pro vypnutí.",
  "plug.bat.on": "Aktivní",
  "plug.main": "Obecné informace",
  "plug.main.consumption": "Aktuální spotřeba",
  "plug.main.power": "Celková spotřeba",
  "plug.main.power_today": "Dnešní spotřeba:",
  "plug.main.power_year": "Roční spotřeba:",
  "plug.main.stat": "Statistiky",
  "plug.overflow": "Řízení podle přetoku",
  "plug.overflow.consumption": "Nastavení odpovídá spotřebiči s příkonem",
  "plug.overflow.help": "Zapínání zásuvky při definovaném přetoku do distribuční sítě. Lze kombinovat s podmínkou času. Při kombinaci podmínek se zásuvka zapne, pokud je splněna alespoň jedna z podmínek pro zapnutí a vypne, pokud je splněna alespoň jedna z podmínek pro vypnutí.",
  "plug.overflow.on": "Aktivní",
  "plug.overflow.startPower": "Zapnout při odběru ze sítě",
  "plug.overflow.startPower.help": "Zásuvka se zapne, pokud je přetok v nastavené výši po definovaný interval zpoždění. Pokud je hodnota nastavena na - 1500W a zpoždění zapnutí je 5 minut, tak zásuvka sepne při přetoku do sítě ve výši alespoň 1500W po dobu 5 minut.",
  "plug.overflow.startPower.subtitle": "Záporná hodnota je přetok, kladná hodnota je odběr",
  "plug.overflow.stopPower": "Vypnout při odběru ze sítě",
  "plug.overflow.stopPower.help": "Zásuvka se vypne, pokud je odběr vyšší než nastavený po definovaný interval zpoždění. Pokud je hodnota nastavena na 100W a zpoždění vypnutí je 5 minut, tak zásuvka vypne při odběru ze sítě ve výši minimálně 100W po dobu 5 minut.",
  "plug.overflow.stopPower.subtitle": "Záporná hodnota je přetok, kladná hodnota je odběr",
  "plug.overflow.time": "Zpoždění zapnutí a vypnutí",
  "plug.overflow.time.help": "Tento parametr slouží pro definici zpoždění zapnutí a vypnutí zásuvky při definovaných přetocích/odběrech. Vhodné pro nastavení priority a eliminace častého spínání zásuvky. Zadávejte ve formátu HH:MM.",
  "plug.plug": "Zásuvka",
  "plug.spot": "Řízení podle spotové ceny",
  "plug.spot.15m.period": "Perioda spotové ceny",
  "plug.spot.15m.period.subtitle": "15 minutové intervaly",
  "plug.spot.help": "Spínání při definované spotové ceně. Lze kombinovat s podmínkou času. Při kombinaci podmínek se zásuvka zapne, pokud je splněna alespoň jedna z podmínek pro zapnutí a vypne, pokud je splněna alespoň jedna z podmínek pro vypnutí.",
  "plug.spot.on": "Aktivní",
  "plug.spot.period": "Perioda spotové ceny",
  "plug.spot.period.subtitle": "60 minutové intervaly",
  "plug.spot.price.period": "Časové rozlišení zásuvky",
  "plug.spot.spotHi": "Aktivovat při vysoké ceně",
  "plug.spot.spotHi.help": "Zásuvka se zapne, pokud je cena spotu na vysoké úrovni viz záložka Spot.",
  "plug.spot.spotLow": "Aktivovat při nízké ceně",
  "plug.spot.spotLow.help": "Zásuvka se zapne, pokud je cena spotu na nízké úrovni viz záložka Spot.",
  "plug.spot.spotMi": "Aktivovat při střední ceně",
  "plug.spot.spotMi.help": "Zásuvka se zapne, pokud je cena spotu na střední úrovni viz záložka Spot.",
  "plug.spot.spot_above_price": "Aktivovat při vyšší než nastavené ceně",
  "plug.spot.spot_above_price.help": "Zásuvka se aktivuje, pokud je cena spotu vyšší nebo rovna nastavené ceně spotu.",
  "plug.spot.spot_above_price.subtitle": "Pokud je cena spotu vyšší nebo rovna této hodnotě, dojde k sepnutí. Pokud je nižší, dojde k rozepnutí.",
  "plug.spot.spot_below_price": "Aktivovat při nižší než nastavené ceně",
  "plug.spot.spot_below_price.help": "Zásuvka se aktivuje, pokud je cena spotu nižší nebo rovna nastavené ceně spotu.",
  "plug.spot.spot_below_price.subtitle": "Pokud je cena spotu nižší nebo rovna této hodnotě, dojde k sepnutí. Pokud je vyšší, dojde k rozepnutí.",
  "plug.spot.spot_neg": "Aktivovat při zákazu přetoků do sítě",
  "plug.spot.spot_neg.help": "Zásuvka se aktivuje, pokud je zakázán přetok do sítě viz plán spotového obchodování.",
  "plug.status": "Režim zásuvky",
  "plug.summary.price": "Cena",
  "plug.summary.price_level": "Hladina ceny",
  "plug.summary.price_level_15m": "Hladina ceny 15m",
  "plug.summary.switch": "Sepnutí zásuvky",
  "plug.summary.time": "Čas",
  "plug.time": "Řízení podle času",
  "plug.time.help": "Spínání při definovaném čase. Lze kombinovat s ostatními podmínkami dle baterie (musí být nainstalována baterie), spotové ceny (musí být povoleno spotové obchodování) a přetoku (musí být povolen přetok do DS). Při kombinaci podmínek se zásuvka zapne, pokud je splněna alespoň jedna z podmínek pro zapnutí a vypne, pokud je splněna alespoň jedna z podmínek pro vypnutí.",
  "plug.time.on": "Aktivní",
  "plug.time.turn_off": "Vypnout v čase",
  "plug.time.turn_off.help": "Čas, ve kterém se zásuvka vypne. Pokud je nastaveno na 12:00, tak se zásuvka vypne přesně v nastavený čas 12:00.",
  "plug.time.turn_on": "Zapnout v čase",
  "plug.time.turn_on.help": "Čas, ve kterém se zásuvka zapne. Pokud je nastaveno na 12:00, tak se zásuvka zapne přesně v nastavený čas 12:00.",
  "plug.turn_off": "Vypnout",
  "plug.turn_on": "Zapnout",
  "pre_flexibility.business_flexibility.title": "Obchodní flexibilita",
  "pre_flexibility.enabled": "Integrace zapnuta",
  "pre_flexibility.title": "PRE Flexibilita",
  "premium.banner.active.button": "Spravovat předplatné",
  "premium.banner.active.dev_mode": "Předplatné je aktivní pro vývoj",
  "premium.banner.active.subtitle": "Předplatné Infigy Plus je aktivní. Můžete si užívat všech vychytávek, které jsou díky němu v aplikaci navíc.",
  "premium.banner.active.title": "Moje Infigy Plus",
  "premium.banner.hide.confirm": "Opravdu chcete skrýt Infigy Plus?",
  "premium.banner.hide.confirm.description": "Kdykoliv můžete Infigy Plus znovu prozkoumat v nastavení aplikace.",
  "premium.banner.hide.later": "Připomenout později",
  "premium.banner.hide.show_more": "Zjistit více",
  "premium.banner.hide.yes": "Skrýt",
  "premium.banner.inactive.button": "Zjistit více",
  "premium.banner.inactive.subtitle": "Posuňte svou správu energií na ještě vyšší úroveň. S Infigy Plus dostanete další chytré nástroje - detailní grafy, okamžité notifikace, vylepšený plánovací kalendář, přehledné reporty a další.",
  "premium.banner.inactive.title": "Infigy Plus není aktivní",
  "premium.dialog.charts.subtitle": "Získejte možnost sledovat výkon jednotlivých stringů, spotřebu dle fází a další podrobné informace.",
  "premium.dialog.charts.title": "Detailní grafy",
  "premium.dialog.notifications.subtitle": "Získávejte notifikace o záporných cenách, nabité baterii a dalších událostech",
  "premium.dialog.notifications.title": "Notifikace",
  "premium.dialog.other_benefits.subtitle": "Připravujeme spoustu dalších benefitů, které budeme postupně uvolňovat pro předplatitele Infigy Plus",
  "premium.dialog.other_benefits.title": "Další benefity přijdou brzy",
  "premium.dialog.reports.subtitle": "Detailní měsíční reporty, které vám poskytnou jasný obraz o výrobě, spotřebě a využití energie ve vaší domácnosti. Všechny důležité údaje máte na jednom místě - srozumitelně, přehledně a doplněné grafy.",
  "premium.dialog.reports.title": "Pokročilé reporty",
  "premium.dialog.save": "Předplatit Infigy Plus",
  "premium.dialog.schedule.subtitle": "Naplánujte si ručně nabíjení či vybíjení baterie dle potřeby",
  "premium.dialog.schedule.title": "Vylepšený plánovací kalendář",
  "premium.dialog.spot.subtitle": "Získtejte možnost nahlédnout do historie spotových cen a plánů, které Infigy v minulosti připravilo",
  "premium.dialog.spot.title": "Historie spotových cen",
  "protocol.settings": "Nastavení",
  "protocol.settings.Licence": "Licence",
  "protocol.settings.distribution": "Distribuce",
  "protocol.test": "Test zařízení",
  "protocol.test.internet-connect": "Připojení k internetu",
  "protocol.test.inverter-connect": "Připojení střídače",
  "protocol.test.phase_1": "Test 1. fáze",
  "protocol.test.phase_2": "Test 2. fáze",
  "protocol.test.phase_3": "Test 3. fáze",
  "protocol.test.tester": "Zařízení otestoval",
  "relay.condition": "Podmínka spínání",
  "relay.main": "Obecné informace",
  "relay.name": "Název relé",
  "relay.spot.diagram": "Spínání podle spotové ceny",
  "relay.status": "Sepnuto",
  "relay.summary.switch": "Sepnutí relé",
  "relay.title": "Relé",
  "report.avg_day_chart.battery_soc": "Nabití baterie",
  "report.avg_day_chart.consumption": "Spotřeba",
  "report.avg_day_chart.grid": "Distribuční síť",
  "report.avg_day_chart.pv_production": "Výroba FVE",
  "report.not_generated": "Vytvořit report kliknutím",
  "report_test.button": "Test",
  "report_test.date": "Měsíc (např. 2025-09)",
  "report_test.generated": "Report vygenerován",
  "report_test.ok": "OK",
  "report_test.test": "Test",
  "reports.accumulation_increased": "Zvýšení akumulace",
  "reports.average_water_temperature": "Průměrná teplota vody",
  "reports.avg_day": "Průmerný den",
  "reports.battery": "Baterie",
  "reports.boiler": "Bojler",
  "reports.building_consumption": "Spotřeba objektu",
  "reports.disclaimer": "Uvedené hodnoty mají pouze informativní charakter a mohou se lišit od oficiálních odečtů distributora.",
  "reports.energy_estimate": "Odhad energií bez řízení",
  "reports.estimated_water_amount": "Odhadované množství vody",
  "reports.grid_consumption": "Odběr ze sítě",
  "reports.grid_consumption_hp": "Spotřeba ze sítě",
  "reports.grid_consumption_hw": "Spotřeba ze sítě",
  "reports.grid_consumption_wallbox": "Spotřeba ze sítě",
  "reports.heat_pump": "Tepelné čerpadlo",
  "reports.household_consumption": "Spotřeba domácnosti",
  "reports.info": "Obecné info",
  "reports.kilometers_driven": "Počet ujetých km",
  "reports.kilometers_driven_from_sun": "Počet ujetých km ze slunce",
  "reports.maximum_power": "Maximální výkon",
  "reports.monthly_consumption": "Měsíční spotřeba",
  "reports.monthly_production": "Měsíční výroba",
  "reports.pv": "Fotovoltaická elektrárna",
  "reports.pv_consumption": "Spotřeba z FVE",
  "reports.pv_production": "Výroba FVE",
  "reports.regenerate_report": "Znovu vygenerovat report",
  "reports.regenerate_report_confirm_title": "Znovu vygenerovat report?",
  "reports.rfid_cards": "RFID karty",
  "reports.self_consumption": "Vlastní využití energie",
  "reports.self_sufficiency": "Soběstačnost",
  "reports.self_sufficient_days": "Počet soběstačních dní",
  "reports.share.description": "Vybraný snímek můžete sdílet s ostatními.",
  "reports.share.share": "Sdílet report",
  "reports.share.title": "Sdílet report",
  "reports.share_report": "Sdílet report",
  "reports.sold_to_distribution_grid": "Prodáno do distribuční sítě",
  "reports.stored_energy_from_grid": "Uložená energie ze sítě",
  "reports.stored_energy_from_pv": "Uložená energie z FVE",
  "reports.stored_energy_to_battery": "Uložená energie do baterie",
  "reports.stored_energy_to_boiler": "Uložená energie do bojleru",
  "reports.stored_energy_to_heat_pump": "Uložená energie do TČ",
  "reports.stored_energy_to_wallbox": "Uložená energie do wallboxu",
  "reports.total_overflow_to_grid": "Celkový přetok do sítě",
  "reports.total_purchase_from_grid": "Celkový nákup ze sítě",
  "reports.total_with_control": "Celkem s řízením",
  "reports.total_without_control": "Celkem bez řízení",
  "reports.updated_at": "Vygenerováno {date}",
  "reports.wallbox": "Wallbox",
  "rfid_cards.col.consumption": "Spotřeba",
  "rfid_cards.col.created_at": "Přidáno",
  "rfid_cards.col.id": "ID karty",
  "rfid_cards.col.name": "Název",
  "rfid_cards.export": "Exportovat CSV",
  "rfid_cards.from": "Od",
  "rfid_cards.no_cards": "Žádné karty nebyly přidány",
  "rfid_cards.title": "RFID karty",
  "rfid_cards.to": "Do",
  "save": "Uložit",
  "schedules.add": "Přidat plán",
  "schedules.battery_charge": "Nabíjení baterie",
  "schedules.battery_discharge": "Vybíjení baterie",
  "schedules.charging_current": "Nabíjecí proud: {chargingCurrent} A",
  "schedules.description": "Naplánujte si vybití nebo nabití baterie podle potřeby.",
  "schedules.dialog.title": "Vytvořit plán",
  "schedules.dialog.title.ev": "Vytvořit plán nabíjení",
  "schedules.ev_charging": "Nabíjení elektromobilu",
  "schedules.form.action": "Akce",
  "schedules.form.battery_charge": "Nabítí baterie",
  "schedules.form.battery_discharge": "Vybití baterie",
  "schedules.form.charging-current": "Nastavit nabíjecí proud",
  "schedules.form.charging-current.auto": "Výchozí",
  "schedules.form.create": "Vytvořit",
  "schedules.form.duration": "Délka",
  "schedules.form.ev_charging": "Nabíjení elektromobilu",
  "schedules.form.frequency": "Frekvence",
  "schedules.form.frequency.daily": "Denně",
  "schedules.form.frequency.monthly": "Měsíčně",
  "schedules.form.frequency.weekly": "Týdně",
  "schedules.form.interval.biweekly": "Každé 2 týdny",
  "schedules.form.preview.hide": "Skrýt náhled",
  "schedules.form.preview.show": "Zobrazit plánované výskyty",
  "schedules.form.preview.title": "Plánovaná spuštění ({count} následujících)",
  "schedules.form.recurring": "Opakující se",
  "schedules.form.target-soc": "Cilové SOC (volitelné)",
  "schedules.form.until": "Opakovat do (volitelné)",
  "schedules.form.when": "Kdy",
  "schedules.loading.error": "Chyba při načítání plánů",
  "schedules.missed": "Neproběhlo",
  "schedules.no_plans_found": "Žádné plány nebyly nalezeny.",
  "schedules.processed": "Proběhlo",
  "schedules.remove.confirm": "Opravdu chcete plán smazat?",
  "schedules.remove.no": "Zrušit",
  "schedules.remove.recurring.instance": "Smazat pouze tento výskyt",
  "schedules.remove.recurring.series": "Smazat celou sérii",
  "schedules.remove.recurring.title": "Smazat opakující se plán",
  "schedules.remove.yes": "Smazat",
  "schedules.running": "Probíhá",
  "schedules.scheduled": "Naplánováno",
  "schedules.show_processed": "Zobrazit provedené",
  "schedules.target_soc": "Cílové SOC: {targetSoc, number, percent}",
  "schedules.title": "Plánovač",
  "scripts.add": "Vytvořit",
  "scripts.delete": "Smazat",
  "scripts.edit": "Upravit",
  "scripts.loading_error": "Chyba při načítání scriptů",
  "scripts.title": "Scripty",
  "settings.PV.NominalInverterPower": "Nominální výkon střídače",
  "settings.PV.NominalInverterPower.help": "Pro Solinteg, Wattsonic a Deye je toto důležité pro správný výpočet přetoků do sítě.",
  "settings.PV.NominalInverterPower.subtitle": "Nominální výkon střídače v kW, důležitý pro výpočet % přetoků do sítě.",
  "settings.PV.StringNumber": "Počet stringů střídače",
  "settings.PV.StringNumber.subtitle": "Počet stringů střídače zobrazovaný v aplikaci na záložce FVE",
  "settings.app_update": "Verze aplikace",
  "settings.app_update.check_button": "Zkontrolovat aktualizace",
  "settings.app_update.confirm.cancel": "Zrušit",
  "settings.app_update.confirm.confirm": "Aktualizovat",
  "settings.app_update.confirm.description": "Aktualizace může trvat několik minut. Během aktualizace bude aplikace nedostupná a následně se automaticky restartuje.",
  "settings.app_update.confirm.title": "Spustit aktualizaci?",
  "settings.app_update.error.no_internet": "Zkontrolujte síťové připojení",
  "settings.app_update.in_progress": "Aktualizace probíhá",
  "settings.app_update.request_button": "Aktualizace je k dispozici",
  "settings.app_update.requested": "Aktualizace byla vyžádána",
  "settings.app_update.subtitle": "Zkontrolujte dostupnost nových verzí",
  "settings.app_update.title": "Aktualizace aplikace",
  "settings.app_update.up_to_date": "Aplikace je aktuální",
  "settings.boiler": "Bojler",
  "settings.boiler.3phase": "Tří-fázová patrona",
  "settings.boiler.3phase.subtitle": "Jedno-fázovou patronu zapojte na SSR výstup odpovídající zvolené fázi.",
  "settings.boiler.HwBatteryPriority": "Procento nabítí baterie od kterého se začne ohřívat bojler",
  "settings.boiler.HwBatteryPriority.help": "Pokud je nabití baterie nižší, než tato hodnota, priorita akumulace energie je plně dostupna baterii. Pokud je nabití baterie vyšší, bojler začíná přebírat prioritu a spouští ohřev vody z přebytečné energie FVE - část energie jde dále do baterie do jejího dobití.",
  "settings.boiler.capacity": "Objem bojleru",
  "settings.boiler.capacity_sub": "Nutné zadat pouze pro spotové obchodování",
  "settings.boiler.enabled": "Topná patrona nainstalována",
  "settings.boiler.nominal": "Nominální příkon",
  "settings.boiler.nominal.subtitle": "Nominální příkon pro 1 fázi elektrokotle",
  "settings.boiler.phase": "Fáze patrony",
  "settings.boiler.phase.subtitle": "L1 = SSR výstup 1, L2 = SSR výstup 2, L3 = SSR výstup 3.",
  "settings.boiler.prio": "Priorita baterie",
  "settings.boiler.prio.subtitle": "Pokud je ON, nejprve se nabijí baterie a následně bojler",
  "settings.boiler.shellies": "Bojler je řízen skrze Shelly",
  "settings.boiler.temp_enabled": "Teplotní čidlo nainstalováno",
  "settings.boiler.temp_enabled.subtitle": "Bojler lze bez čidla využít pouze pro přebytky",
  "settings.device": "Zařízení",
  "settings.device.SN": "Sériové číslo",
  "settings.device.id": "ID zařízení",
  "settings.device.license": "Licence zařízení",
  "settings.docs": "Návody a další podklady",
  "settings.docs.service_settings_inverter.button": "Přejít na wiki",
  "settings.docs.service_settings_inverter.subtitle": "Dokumentace, postupy a další informace",
  "settings.docs.service_settings_inverter.title": "Návod na připojení střídače",
  "settings.docs.tech_wiki.button": "Přejít na wiki",
  "settings.docs.tech_wiki.subtitle": "Návody, postupy a další informace",
  "settings.docs.tech_wiki.title": "Technická wiki",
  "settings.docs.user_wiki.button": "Přejít na wiki",
  "settings.docs.user_wiki.subtitle": "Návody, postupy a další informace",
  "settings.docs.user_wiki.title": "Uživatelská wiki",
  "settings.hdo": "Nastavení časů HDO",
  "settings.hdo.help": "Nastavení časů HDO pro výpočet cen elektřiny ve vysokém a nízkém tarifu. Níže je možné zadat časy platnosti nízkého tarifu.",
  "settings.hdo.on1": "Čas 1",
  "settings.hdo.on2": "Čas 2",
  "settings.hdo.on3": "Čas 3",
  "settings.hdo.on4": "Čas 4",
  "settings.hdo.on5": "Čas 5",
  "settings.hdo.on6": "Čas 6",
  "settings.hdo.regular": "Běžný pracovní den",
  "settings.hdo.start": "Zapnout",
  "settings.hdo.stop": "Vypnout",
  "settings.hdo.type": "Definovat časy pro",
  "settings.hdo.weekend": "Víkendové časy HDO",
  "settings.heatpump": "Tepelné čerpadlo",
  "settings.heatpump.HpBatteryPriority": "Procento nabítí baterie od kterého se zvýší výkon tepelného čerpadla",
  "settings.heatpump.HpBatteryPriority.help": "Pokud je nabití baterie nižší, než tato hodnota, priorita akumulace energie je plně dostupna baterii. Pokud je nabití baterie vyšší, tepelné čerpadlo začíná přebírat prioritu a spouští ohřev vody z přebytečné energie FVE - část energie jde dále do baterie do jejího dobití.",
  "settings.heatpump.enabled": "Tepelné čerpadlo nainstalováno",
  "settings.heatpump.flexiAN": "Flexibilita AN",
  "settings.heatpump.flexiCool": "Flexibilita chlazení",
  "settings.heatpump.flexiHw": "Flexibilita teplé vody",
  "settings.heatpump.flexiRoom": "Flexibilita místnosti",
  "settings.heatpump.hp_type": "Typ tepelného čerpadla",
  "settings.heatpump.nominal": "Nominální příkon",
  "settings.heatpump.nominal1": "Nominální příkon",
  "settings.heatpump.priority": "Tepelné čerpadlo má vyšší prioritu, než baterie",
  "settings.heatpump.priority-wb": "Tepelné čerpadlo má vyšší prioritu, než wallbox",
  "settings.heatwatter": "Bojler",
  "settings.heatwatter.legionella": "Legionella",
  "settings.heatwatter.legionella_temp": "Teplota sanace",
  "settings.heatwatter.legionella_temp.subtitle": "Teplota na kterou se musí minimálně 1x za 14 dní bojler nahřát",
  "settings.inverter_communication_status": "Komunikace se střídačem",
  "settings.inverter_communication_status.not_ok": "Nenavázána,{br}pokouším se o spojení...",
  "settings.inverter_communication_status.ok": "Komunikace navázána{br}({count} čtení)",
  "settings.inverter_communication_status.subtitle": "Navázání komunikace může trvat několik desítek vteřin až pár minut",
  "settings.notification": "Notifikace",
  "settings.notification.battery_max_soc": "Maximální SOC baterie",
  "settings.notification.battery_max_soc.subtitle": "Notifikace se vygeneruje při dosažení nastaveného maximálního SOC baterie. Notifikace se vygeneruje pouze 1x denně.",
  "settings.notification.battery_max_soc_value": "Maximální SOC baterie pro notifikace",
  "settings.notification.battery_max_soc_value.subtitle": "Nastavte SOC baterie, při jehož dosažení se vygeneruje notifikace.",
  "settings.notification.battery_min_soc": "Minimální SOC baterie",
  "settings.notification.battery_min_soc.subtitle": "Notifikace se vygeneruje při poklesu SOC baterie na nastavenou minimální hodnotu. Notifikace se vygeneruje pouze 1x denně.",
  "settings.notification.battery_min_soc_value": "Minimální SOC baterie pro notifikace",
  "settings.notification.battery_min_soc_value.subtitle": "Nastavte SOC baterie. Při poklesu na tuto hodnotu se vygeneruje notifikace.",
  "settings.notification.daily_prediction.subtitle": "Notifikace se vygeneruje každý den v 8:00",
  "settings.notification.heat_pump_limit_exceeded": "Překročení limitu spotřeby tepelného čerpadla",
  "settings.notification.heat_pump_limit_exceeded.subtitle": "Notifikace se vygeneruje při překročení nastaveného limitu spotřeby tepelného čerpadla",
  "settings.notification.heat_pump_limit_value": "Denní limit spotřeby tepelného čerpadla pro notifikace",
  "settings.notification.heat_pump_limit_value.subtitle": "Nastavte limit spotřeby tepelného čerpadla, při jehož překročení se vygeneruje notifikace.",
  "settings.notification.heat_water_limit_exceeded": "Překročení limitu ohřevu vody",
  "settings.notification.heat_water_limit_exceeded.subtitle": "Notifikace se vygeneruje při překročení nastaveného limitu ohřevu vody",
  "settings.notification.heat_water_limit_value": "Denní limit ohřevu vody pro notifikace",
  "settings.notification.heat_water_limit_value.subtitle": "Nastavte limit ohřevu vody, při jehož překročení se vygeneruje notifikace.",
  "settings.notification.heat_water_max_temperature": "Dosažena maximální teplota vody v bojleru",
  "settings.notification.heat_water_max_temperature.subtitle": "Notifikace se vygeneruje při dosažení požadované maximální teploty vody v bojleru z FV energie",
  "settings.notification.home_consumption_limit_exceeded": "Překročení limitu spotřeby domácnosti",
  "settings.notification.home_consumption_limit_exceeded.subtitle": "Notifikace se vygeneruje při překročení nastaveného limitu spotřeby domácnosti",
  "settings.notification.home_consumption_limit_value": "Denní limit spotřeby domácnosti pro notifikace",
  "settings.notification.home_consumption_limit_value.subtitle": "Nastavte limit spotřeby domácnosti, při jehož překročení se vygeneruje notifikace.",
  "settings.notification.iverter_disconnected": "Výpadek komunikace střídače",
  "settings.notification.iverter_disconnected.subtitle": "Notifikace se vygeneruje při začátku a konci výpadku komunikace se střídačem",
  "settings.notification.negative_spot": "Záporná cena na spotu",
  "settings.notification.negative_spot.subtitle": "Notifikace se vygeneruje při začátku a konci záporné ceny na spotu",
  "settings.notification.pv_production_mwh": "Milník ve výrobě FV energie",
  "settings.notification.pv_production_mwh.subtitle": "Notifikace se vygeneruje pokud FVE vygeneruje MWh energie v daném roce",
  "settings.notification.spot_charging_battery": "Start a konec nabíjení baterie dle spotové ceny",
  "settings.notification.spot_charging_battery.subtitle": "Notifikace se vygeneruje při začátku a konci nabíjení baterie dle spotové ceny",
  "settings.notification.spot_daily_prediction": "Denní předpověď",
  "settings.notification.spot_daily_summary": "Denní souhrn plánu spotu",
  "settings.notification.spot_daily_summary.subtitle": "Notifikace se vygeneruje každý den v 8:00",
  "settings.notification.spot_discharging_battery": "Start a konec vybíjení baterie do sítě dle spotové ceny",
  "settings.notification.spot_discharging_battery.subtitle": "Notifikace se vygeneruje při začátku a konci vybíjení baterie do sítě dle spotové ceny",
  "settings.notification.utility_loss": "Výpadek distribuční sítě",
  "settings.notification.utility_loss.subtitle": "Notifikace se vygeneruje při začátku a konci výpadku distribuční sítě",
  "settings.notification.wallbox_charging_start_stop": "Start a konec nabíjení elektromobilu",
  "settings.notification.wallbox_charging_start_stop.subtitle": "Notifikace se vygeneruje při začátku a konci nabíjení elektromobilu",
  "settings.notification.wallbox_limit_exceeded": "Překročení limitu nabíjení elektromobilu",
  "settings.notification.wallbox_limit_exceeded.subtitle": "Notifikace se vygeneruje při překročení nastaveného limitu nabíjení elektromobilu",
  "settings.notification.wallbox_limit_value": "Denní limit nabíjení elektromobilu pro notifikace",
  "settings.notification.wallbox_limit_value.subtitle": "Nastavte limit nabíjení elektromobilu, při jehož překročení se vygeneruje notifikace.",
  "settings.notification.webapp.subtitle": "Notifikace z Infigy můžete dostávat přes webovou aplikaci.",
  "settings.notification.webapp.title": "Webová aplikace",
  "settings.other": "Ostatní",
  "settings.other.dark_mode": "Tmavý režim",
  "settings.other.languate": "Jazyk",
  "settings.other.overflow_fronius": "Maximální přetok do sítě je omezován na straně Fronius střídače",
  "settings.other.overflow_fronius_subtitle": "Tato hodnota je stanovena distributorem. Překročení této hodnoty může vést k finančním postihům ze strany distributora.",
  "settings.other.overflow_settings": "Nastavená hodnota přetoků",
  "settings.other.overflow_settings.help": "Jedná se o servisně nastavenou hodnotu maximálního přetoku. Tato hodnota je stanovena distributorem. Překročení této hodnoty může vést k finančním postihům ze strany distributora.",
  "settings.other.readability_mode": "Velikost písma",
  "settings.photovoltaics": "Fotovoltaická elektrárna",
  "settings.photovoltaics.backup_enabled": "Backup povolen",
  "settings.photovoltaics.backup_enabled.subtitle": "Informace o nastavení režimu backup střídače.",
  "settings.photovoltaics.batterychargingpower": "Nabíjecí výkon baterie",
  "settings.photovoltaics.batterychargingpower_sub": "Výkon pro manuální nabíjení baterie a spotové nabíjení z distribuční sítě",
  "settings.photovoltaics.batterydischargingpower": "Vybíjecí výkon baterie",
  "settings.photovoltaics.batterydischargingpower_sub": "Výkon pro spotové vybíjení baterie do distribuční sítě",
  "settings.photovoltaics.batteryenabled": "Baterie nainstalována",
  "settings.photovoltaics.batterynominal": "Nominální kapacita baterie",
  "settings.photovoltaics.batterynominal_sub": "Nutné zadat pouze pro spotové obchodování",
  "settings.photovoltaics.enabled": "FVE nainstalována",
  "settings.photovoltaics.gridchargeenabled": "Nabíjení baterie z distribuční sítě povoleno",
  "settings.photovoltaics.inverters-adjust-power": "Aktuální výkon střídačů",
  "settings.photovoltaics.inverters-nominal": "Nominální výkon řiditelných střídačů",
  "settings.photovoltaics.nominal": "Nominální výkon v panelech celé elektrárny",
  "settings.photovoltaics.overflow": "Přetok do sítě bez omezení",
  "settings.photovoltaics.overflow.value": "Omezení přetoku",
  "settings.photovoltaics.overflow.value.help": "Hodnota omezení přetoku do distribuční sítě. Tato hodnota se zapíše do střídače. Ve střídači tuto hodnotu neupravujte. Omezení přetoku je řízené z Infigy. Zapsanou hodnotu si zkontrolujte ve střídači.",
  "settings.photovoltaics.overflow_fronius.value.help": "Hodnota přetoku na straně Fronius střídače. Slouží jako informace Infigy pro správnou vizualizaci přetoků.",
  "settings.photovoltaics.settings": "Baterie",
  "settings.photovoltaics.settings.soc_actual": "Vypočtené minimální nabití",
  "settings.photovoltaics.settings.soc_actual.help": "Tato hodnota je automaticky vypočtena na základě aktuálního stavu. Buď se řídí dle automatického řízení nabití podle ročního období, nebo dle manuálního nastavení minimálního nabití s DS a bez DS. Pokud je zde hodnota 100%, tak je vybíjení baterie zakázané, např. dle spotového obchodování.",
  "settings.photovoltaics.settings.soc_grid": "Minimální nabití s DS",
  "settings.photovoltaics.settings.soc_grid.help": "Touto hodnotou je možné řídit minimální nabití baterie v % SOC při dostupné distribuční síti. U Solax v režimu Backup je minimální nabití baterie 15%.",
  "settings.photovoltaics.settings.temp_ek": "Minimální nabití bez DS",
  "settings.photovoltaics.settings.temp_ek.help": "Touto hodnotou je možné řídit minimální nabití baterie v % SOC při výpadku distribuční sítě.",
  "settings.photovoltaics.unbalanced_enabled": "Asymetrie střídače",
  "settings.photovoltaics.unbalanced_enabled.subtitle": "Informace o nastavení režimu asymetrie střídače.",
  "settings.photovoltaics_auto_settings": "Automatické řízení nabití",
  "settings.photovoltaics_auto_settings.subtitle": "Automatická regulace nabití podle ročního období",
  "settings.plug": "Zásuvky",
  "settings.plug.Led": "Trvalé podsvícení",
  "settings.plug.Led-batt": "Podsvícení při nabité baterii",
  "settings.plug.Led-batt.subtitle": "Podsvícení aktivní, pokud má baterie alespoň 95%",
  "settings.plug.Led-over": "Podsvícení při přetoku",
  "settings.plug.enabled": "Zásuvky nainstalovány",
  "settings.plug.enabled.subtitle": "Zásuvky na lokální síti",
  "settings.plug.enabled2": "Druhá zásuvka",
  "settings.plug.enabled3": "Třetí zásuvka",
  "settings.plug.ip1": "IP adresa první zásuvky",
  "settings.plug.ip1.label": "IP 1",
  "settings.plug.ip2": "IP adresa druhé zásuvky",
  "settings.plug.ip2.label": "IP 2",
  "settings.plug.ip3": "IP adresa třetí zásuvky",
  "settings.plug.ip3.label": "IP 3",
  "settings.plug.modulenabled": "Zásuvky na modulu Shelly PRO 3",
  "settings.plug.modulip": "IP adresa modulu",
  "settings.plug.modulip.label": "IP Modulu",
  "settings.plug.name1": "Název zásuvky 1",
  "settings.plug.name1.label": "Název",
  "settings.plug.name2": "Název zásuvky 2",
  "settings.plug.name2_label": "Název",
  "settings.plug.name3": "Název zásuvky 3",
  "settings.plug.name3.label": "Název",
  "settings.plug.statusLed": "Signalizační dioda",
  "settings.readability_mode.default": "Výchozí",
  "settings.readability_mode.large": "Velká",
  "settings.relay.above_price_relay": "Cena spotu pro sepnutí relé",
  "settings.relay.above_price_relay.subtitle": "Při cene spotu nad tuto hodnotu dojde k sepnutí relé. Pokud je cena nižší, dojde k rozepnutí relé.",
  "settings.relay.above_price_relay_15m": "Cena spotu pro sepnutí relé (15 min)",
  "settings.relay.above_price_relay_15m.subtitle": "Při cene spotu nad tuto hodnotu dojde k sepnutí relé. Pokud je cena nižší, dojde k rozepnutí relé.",
  "settings.relay.above_soc_relay": "Nabití baterie pro sepnutí relé",
  "settings.relay.above_soc_relay.subtitle": "Při nabití baterie nad tuto hodnotu dojde k sepnutí relé",
  "settings.relay.above_soc_relay_hyst": "Hystereze baterie pro rozepnutí relé",
  "settings.relay.above_soc_relay_hyst.subtitle": "Pokud se nabití baterie sníží o tuto hodnotu pod nastavenou pro sepnutí, dojde k rozepnutí relé",
  "settings.relay.below_price_relay": "Cena spotu pro sepnutí relé",
  "settings.relay.below_price_relay.subtitle": "Při cene spotu pod tuto hodnotu dojde k sepnutí relé. Pokud je cena vyšší, dojde k rozepnutí relé.",
  "settings.relay.below_price_relay_15m": "Cena spotu pro sepnutí relé (15 min)",
  "settings.relay.below_price_relay_15m.subtitle": "Při cene spotu pod tuto hodnotu dojde k sepnutí relé. Pokud je cena vyšší, dojde k rozepnutí relé.",
  "settings.relay.below_soc_relay": "Nabití baterie pro sepnutí relé",
  "settings.relay.below_soc_relay.subtitle": "Při poklesu nabití baterie pod tuto hodnotu dojde k sepnutí relé",
  "settings.relay.below_soc_relay_hyst": "Hystereze baterie pro rozepnutí relé",
  "settings.relay.below_soc_relay_hyst.subtitle": "Pokud se nabití baterie zvýší o tuto hodnotu nad nastavenou pro sepnutí, dojde k rozepnutí relé",
  "settings.relay.enabled": "Relé nainstalovány",
  "settings.relay.enabled.subtitle": "Integrovaná relé",
  "settings.relay.item.enabled": "Relé {index}",
  "settings.relay.item.name": "Pojmenování relé",
  "settings.relay.item.status": "Sepnuto",
  "settings.relay.option": "Podmínka",
  "settings.relay.temp_above_relay.subtitle": "Při teplotě bojleru nad tuto hodnotu dojde k sepnutí relé",
  "settings.relay.temp_above_relay_hyst.subtitle": "Pokud se teplota bojleru sníží o tuto hodnotu pod nastavenou pro sepnutí, dojde k rozepnutí relé",
  "settings.relay.temp_below_relay.subtitle": "Při teplotě bojleru pod tuto hodnotu dojde k sepnutí relé",
  "settings.relay.temp_below_relay_hyst": "Hystereze bojleru pro rozepnutí relé",
  "settings.relay.temp_below_relay_hyst.subtitle": "Pokud se teplota bojleru zvýší o tuto hodnotu nad nastavenou pro sepnutí, dojde k rozepnutí relé",
  "settings.relay.temp_relay": "Teplota bojleru pro sepnutí relé",
  "settings.relay.temp_relay_hyst": "Hystereze bojleru pro rozepnutí relé",
  "settings.relay.type.Active": "Trvale sepnuto",
  "settings.relay.type.HDO": "Zrcadlit HDO",
  "settings.relay.type.batteryBelowSOC": "Nabití baterie pod nastavené SOC",
  "settings.relay.type.batteryDischarge": "Vybíjení baterie do sítě",
  "settings.relay.type.batteryFull": "Nabití baterie nad nastavené SOC",
  "settings.relay.type.batteryLow": "Nabití baterie pod nastavené minimum",
  "settings.relay.type.bojlerFull": "Bojler je téměř natopený",
  "settings.relay.type.hdo": "Zrcadlit HDO",
  "settings.relay.type.heatWaterAboveTemp": "Bojler je natopený nad nastavenou teplotu",
  "settings.relay.type.heatWaterBelowTemp": "Bojler je natopený pod nastavenou teplotu",
  "settings.relay.type.heatWaterMaxTemp": "Bojler je téměř natopený",
  "settings.relay.type.heatWaterTemp": "Bojler je natopený nad nastavenou teplotu",
  "settings.relay.type.none": "Není použito, trvale rozepnuto",
  "settings.relay.type.plug1": "Zásuvka 1",
  "settings.relay.type.plug2": "Zásuvka 2",
  "settings.relay.type.plug3": "Zásuvka 3",
  "settings.relay.type.plug4": "Zásuvka 4",
  "settings.relay.type.spotBatteryDischarge": "Vybíjení baterie do sítě",
  "settings.relay.type.spotHi": "Vysoká cena spotu (60 min)",
  "settings.relay.type.spotHi15M": "Vysoká cena spotu (15 min)",
  "settings.relay.type.spotLow": "Nízká cena spotu (60 min)",
  "settings.relay.type.spotLow15M": "Nízká cena spotu (15 min)",
  "settings.relay.type.spotMi": "Střední cena spotu (60 min)",
  "settings.relay.type.spotMi15M": "Střední cena spotu (15 min)",
  "settings.relay.type.spotNegative": "Zákaz přetoků do sítě (60 min)",
  "settings.relay.type.spotNegative15M": "Zákaz přetoků do sítě (15 min)",
  "settings.relay.type.spotPriceAbove": "Cena spotu nad nastavenou hodnotu (60 min)",
  "settings.relay.type.spotPriceAbove15M": "Cena spotu nad nastavenou hodnotu (15 min)",
  "settings.relay.type.spotPriceBelow": "Cena spotu pod nastavenou hodnotu (60 min)",
  "settings.relay.type.spotPriceBelow15M": "Cena spotu pod nastavenou hodnotu (15 min)",
  "settings.relay.type.spotStopAccumulation": "Akumulace zastavena, aktivní prodej",
  "settings.relay.type.stopAccumulation": "Akumulace zastavena, aktivní prodej",
  "settings.relay.type.thermostat1": "Termostat 1",
  "settings.relay.type.thermostat2": "Termostat 2",
  "settings.relay.type.thermostat3": "Termostat 3",
  "settings.relay.type.thermostat4": "Termostat 4",
  "settings.relay.user_advanced_control": "Zobrazit stránku s informacemi uživateli",
  "settings.relay.user_advanced_control.subtitle": "Při povolení se objeví stránka v navigaci",
  "settings.service": "Servis",
  "settings.service.connection_type": "Připojení",
  "settings.service.customer": "Jméno uživatele",
  "settings.service.customer-email": "Email uživatele",
  "settings.service.customer-email-subtitle": "Pokud nemá uživatel založen účet pod tímto emailem, dojde k automatickému vytvoření účtu a odeslání registračního emailu",
  "settings.service.customer-email.label": "Email",
  "settings.service.customer-subtitle": "Slouží k identifikaci instalace pro firmu i zákazníka",
  "settings.service.customer.label": "Jméno",
  "settings.service.exit": "Odhlásit ze servisu",
  "settings.service.exit.button": "Odhlásit",
  "settings.service.info": "Instalace",
  "settings.service.inverter_type": "Typ střídače",
  "settings.service.inverter_type.label": "Střídač",
  "settings.service.modbus_tcp": "LAN/WiFi",
  "settings.service.network": "Síť",
  "settings.service.network.help.content": "V seznamu je možné vidět aktuálně připojená zařízení do sítě Infigy (WiFi nebo kabelem), jejich IP adresy, MAC adresy, atd. Pokud zařízení používá DHCP, je možné kliknutím na špendlík a zafixovat IP adresu, kterou pak DHCP server vždy bude přiřazovat - toto je vhodné např. pro střídač, tepelné čerpadlo, apod. Pokud zařízení používá statickou IP adresu, nemusí se zobrazovat správně.",
  "settings.service.network.help.title": "Nastavení sítě",
  "settings.service.network.mac": "MAC adresa",
  "settings.service.network.online.internet": "Přístup na internet",
  "settings.service.network.online.internet.help": "Přístup na internet je potřeba pro vzdálený přístup, aktualizace systému, spotové ceny a další funkce. Pro plnou funkčnost musí být všechny tři indikátory zelené.{br}{br}První indikátor zobrazuje dostupnost internetu (ping 8.8.8.8).{br}{br}Druhý indikátor zobrazuje dostupnost internetu včetně DNS (ping infigy.cz).{br}{br}Třetí indikátor zobrazuje přístup k interním cloudovým službám Infigy (dostupnost VPN).{br}{br}Pokud je s připojením problém, zkontrolujte prosím kabel, nebo kontaktujte správce sítě, jestli nemá místní síť restrikce na komunikaci do internetu.{br}{br}{wikiLink}",
  "settings.service.network.online.internet.help.wikiLink": "Více informací v naší wiki.",
  "settings.service.network.wan": "WAN adresa",
  "settings.service.network.wifi_passphrase": "Heslo WiFi sítě",
  "settings.service.network_type": "Síť",
  "settings.service.network_type.custom": "Ruční nastavení adresy",
  "settings.service.network_type.external": "Místní síť (zákazníka)",
  "settings.service.network_type.internal": "Interní síť Infigy",
  "settings.service.password": "Přístup do servisu",
  "settings.service.password.label": "Heslo",
  "settings.service.relay": "Relé",
  "settings.service.reset": "Reset chyb",
  "settings.service.reset.button": "Reset chyb",
  "settings.service.rs485": "RS485",
  "settings.service.service-email": "Email servisní firmy",
  "settings.service.service-email-subtitle": "Pro propojení zařízení s instalačním účtem je nutné zadat email servisní firmy, který je uložen v Partnerské sekci aplikace",
  "settings.service.service-email.label": "Email",
  "settings.service.servicer": "Jméno instalačního technika",
  "settings.service.servicer.label": "Jméno",
  "settings.service.solidsun_op": "SolidSun OP",
  "settings.service.solidsun_op.label": "SolidSun OP",
  "settings.service.spot": "Spotové obchodování",
  "settings.service.tester.label": "Jméno testera",
  "settings.service.thermostat": "Termostat",
  "settings.service.town": "Lokalita (obec)",
  "settings.service.version": "Verze aplikace",
  "settings.service.wallbox_type": "Typ wallbox",
  "settings.service.wallbox_type.label": "Wallbox",
  "settings.spot": "Spot",
  "settings.spot.battery.stop_discharge_auto": "Automatické řízení zákazu vybíjení",
  "settings.spot.battery.stop_discharge_auto.help": "Pokud zvolíte tuto možnost, tak systém automaticky bude řídit vybíjení baterie a povolí ho pouze při nejvyšších denních cenách na spotu.",
  "settings.spot.battery.stop_discharge_auto.subtitle": "Řízení uschová energii automaticky na nejdražší hodiny.",
  "settings.spot.battery.stop_discharge_high_price": "Zákaz vybíjení baterie při nízké a střední ceně",
  "settings.spot.battery.stop_discharge_high_price.help": "Pokud zvolíte tuto možnost, tak při nízké a střední ceně spotu se nebude využívat energie z baterie. Systém nebude baterii vybíjet ani do spotřeby objektu. Ta se využije při vyšších cenách.",
  "settings.spot.battery.stop_discharge_low_price": "Zákaz vybíjení baterie při nízké ceně",
  "settings.spot.battery.stop_discharge_low_price.help": "Pokud zvolíte tuto možnost, tak při nízké ceně spotu se nebude využívat energie z baterie. Systém nebude baterii vybíjet ani do spotřeby objektu. Ta se využije při vyšších cenách (střední a vysoká cena).",
  "settings.spot.battery.stop_discharge_low_price.subtitle": "Řízení uschová energii na střední a vysokou cenu energie",
  "settings.spot.battery.stop_discharge_middle_price.subtitle": "Řízení uschová energii na vysokou cenu energie",
  "settings.spot.battery_all_overflow_price": "Minimální cena pro vybíjení celé kapacity baterie do sítě",
  "settings.spot.battery_all_overflow_price.help": "Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení kapacity baterie do sítě až do nastaveného minimálního SOC. Znamená to tedy, že v baterii nebude uchována energie pro noční a ranní spotřebu. Po vybití baterie do sítě se bude pro spotřebu objektu nakupovat energie ze sítě",
  "settings.spot.battery_all_overflow_price.subtitle": "Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení kapacity baterie do sítě až do nastaveného minimálního SOC",
  "settings.spot.battery_charge": "Povoleno nabíjení baterie podle spotu",
  "settings.spot.battery_charge.help": "Pokud zvolíte tuto možnost, tak systém naplánuje nabíjení v době nejnižších cen. Bere v potaz aktuální úroveň nabití baterie a její kapacitu. Na základě těchto parametrů zvolí délku nabíjení tak, aby došlo k jejímu nabití za co nejnižší cenu.",
  "settings.spot.battery_charge.subtitle": "Řízení baterie podle spotu zvýší amortizaci baterie",
  "settings.spot.battery_max_soc": "Finální SOC baterie",
  "settings.spot.battery_max_soc.subtitle": "Maximální nabití baterie při nabíjení ze sítě",
  "settings.spot.battery_overflow": "Povolit vybíjení baterie do sítě podle spotu",
  "settings.spot.battery_overflow.help": "Pokud zvolíte tuto možnost, tak systém naplánuje vybíjení baterie do sítě v době nejvyšší denní ceny a vybije jen tu energii, která nebude potřeba na běžnou spotřebu objektu. Parametry níže je možné definovat výši ceny pro vybítí celé kapacity baterie a vybítí jen té části kapacity baterie, která nebude potřeba pro noční spotřebu.",
  "settings.spot.battery_overflow.subtitle": "Umožní vybít nadbytek energie z baterie do sítě v nejvýhodnější hodinu",
  "settings.spot.battery_overflow_price": "Minimální cena pro vybíjení baterie do sítě",
  "settings.spot.battery_overflow_price.help": "Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení pouze přebytečné kapacity baterie do sítě. Znamená to tedy, že v baterii uchováváme energii pro noční a ranní spotřebu objektu. Nebude tedy docházet k nakupování energie ze sítě",
  "settings.spot.battery_overflow_price.subtitle": "Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení pouze přebytečné kapacity baterie do sítě",
  "settings.spot.battery_strategy": "Strategie spotového nabíjení baterie",
  "settings.spot.battery_strategy.help": "Tímto posuvníkem můžete jednoduše nastavit preferenci využití baterie při spotovém obchodování. Nižší hodnoty (od 20 %) znamenají menší cyklování baterie a tedy méně časté nabíjení/vybíjení za spotové ceny. Vyšší hodnoty (až do 70 %) značí opak.",
  "settings.spot.battery_strategy_service.subtitle": "Touto volbou povolíte koncovým uživatelům nastavit strategii baterie na záložce Spot",
  "settings.spot.battery_strategy_user": "Umožnit nastavení strategie baterie uživatelem",
  "settings.spot.battery_strategy_user.subtitle": "20 % = Spíše využívat baterii pro FVE. 70 % = Spíše využívat baterii pro Spot.",
  "settings.spot.install": "Spotové obchodování aktivní",
  "settings.spot.latitude": "Zeměpisná šířka",
  "settings.spot.latitude.mess": "Šířka",
  "settings.spot.longitude": "Zeměpisná délka",
  "settings.spot.longitude.mess": "Délka",
  "settings.spot.min_difference_price_charge_from_grid": "Minimální rozdíl ceny na spotu pro nabíjení baterie ze sítě",
  "settings.spot.min_difference_price_charge_from_grid.help": "Tímto parametrem je možné řídit nabíjení baterie ze spotu při nízkém rozdílu mezi nejnižší a nejvyšší cenou. Pokud je parametr 2 Kč a rozdíl mezi nejvyšší cenou (3 Kč) a nejnižší cenou (1 Kč) spotu je nižší, tak se v tento den nabíjení baterie ze sítě nenaplánuje. Tento parametr je možné editovat jen v servisním menu.",
  "settings.spot.min_difference_price_charge_from_grid.subtitle": "Minimální rozdíl ceny na spotu během dne, aby mohlo dojít k nabíjení baterie ze sítě",
  "settings.spot.overflow": "Povolit optimalizaci přetoku podle spotu",
  "settings.spot.overflow.help": "Pokud zvolíte tuto možnost, tak systém upřednostní přetok do sítě před nabíjením baterie v době vyšších a středních spotových cen. Děje se pouze v ročních obdobích, ve kterých předpokládáme přebytek energie z FVE a dochází k tomu zpravidla ráno. Optimalizace neprobíhá v nízkých spotových cenách, kdy je prioritou nabíjení baterie z FVE.",
  "settings.spot.overflow.subtitle": "Umožní upřednostnění přetoku před akumulací",
  "settings.spot.overflow_offset": "Maximální přetok při záporné ceně",
  "settings.spot.overflow_offset.help": "Hodnota udává přetok do distribuční sítě při záporné ceně. Tuto funkci doporučujeme využívat v případě energetické komunity.",
  "settings.spot.overflow_offset.subtitle": "Hodnotu není možné nastavit vyšší než maximální přetok",
  "settings.spot.price.period": "Časové rozlišení",
  "settings.spot.price_above_price": "Nastavená cena spotu",
  "settings.spot.price_below": "Nastavená cena spotu",
  "settings.spot.price_distribution_hi": "Cena za distribuci ve vysokém tarifu",
  "settings.spot.price_distribution_hi.help": "Cena za distribuci ve vysokém tarifu v kč/kWh. Tato cena se přičítá k ceně spotu, pokud je aktivní vysoký tarif. Musí být nastaveny časy HDO pro správný výpočet ceny ve vysokém a nízkém tarifu. Tuto částku hledejte ve vyúčtování za elektřinu.",
  "settings.spot.price_distribution_low": "Cena za distribuci v nízkém tarifu",
  "settings.spot.price_distribution_low.help": "Cena za distribuci v nízkém tarifu v kč/kWh. Tato cena se přičítá k ceně spotu, pokud je aktivní nízký tarif. Musí být nastaveny časy HDO pro správný výpočet ceny ve vysokém a nízkém tarifu. Tuto částku hledejte ve vyúčtování za elektřinu.",
  "settings.spot.price_offset": "Cena pro zákaz přetoků",
  "settings.spot.price_offset.help": "Doporučujeme nastavit minimálně ve výši provize/poplatku obchodníkovi za prodej přetoků do sítě.",
  "settings.spot.price_offset.subtitle": "Minimální cena spotu, pod kterou se zakazují přetoky. Hodnota je porovnávána s denním trhem bez distribuční sazby.",
  "settings.spot.region": "Region",
  "settings.thermostat.hp-blocked": "Blokace tepelného čerpadla",
  "settings.thermostat.hysteresis": "Hystereze teploty",
  "settings.thermostat.install": "Termostat aktivní",
  "settings.thermostat.name.label": "Název",
  "settings.thermostat.name1": "Pojmenování termostatu 1",
  "settings.thermostat.name2": "Pojmenování termostatu 2",
  "settings.thermostat.name3": "Pojmenování termostatu 3",
  "settings.thermostat.name4": "Pojmenování termostatu 4",
  "settings.thermostat.nominal": "Nominální příkon zdroje",
  "settings.thermostat.number-of-thermostat": "Počet termostatů",
  "settings.utility": "Parametry domu",
  "settings.utility.loadpercent": "Aktuální zatížení jističe",
  "settings.utility.numberofphase": "Tří-fázová instalace",
  "settings.utility.settings.ampers": "Velikost jističe",
  "settings.utility.settings.loadpercent": "Krizové zatížení",
  "settings.utility.settings.loadpercent_max": "Při překročení dochází k omezování spotřeby",
  "settings.wallbox": "Wallbox",
  "settings.wallbox.install": "Wallbox aktivní",
  "settings.wallbox.name": "Název wallboxu {number}",
  "settings.wallbox.spot": "Wallbox",
  "shellies.list": "Shellies",
  "shellies.mqtt_broker_running": "Stav MQTT Brokerka",
  "shellies.settings": "Nastavení",
  "shellies.settings.boiler.active": "Bojler připojený přes Shellies",
  "shellies.settings.boiler.id": "ID shellies",
  "shellies.settings.boiler.id.label": "ID",
  "shellies.title": "Shellies",
  "spot.draft": "Režimy pro dnešek",
  "spot.draft.actualpricehi": "Aktuální cena je vysoká, sniž spotřebu",
  "spot.draft.actualpricelow": "Aktuální cena je nízká, zvyš spotřebu",
  "spot.draft.hesLevel": "Úroveň řízení HES",
  "spot.draft.hiprice": "Hranice sníženého odběru",
  "spot.draft.info": "Režimy a doporučení pro dnešní den",
  "spot.draft.lowprice": "Hranice zvýšeného odběru",
  "spot.draft.todaystatus_HP": "Akumulace tepelka",
  "spot.draft.todaystatus_HW": "Akumulace bojleru",
  "spot.draft.todaystatus_bat": "Akumulace baterie",
  "spot.draft.todaystatus_em": "Přetok",
  "spot.flexibility": "Odhad flexibility pro dnešek",
  "spot.prediction": "Odhady energií pro dnešek",
  "spot.prediction.battery": "Dispoziční akumulace baterie",
  "spot.prediction.home": "Běžná spotřeba objektu",
  "spot.prediction.hp": "Tepelné čerpadlo",
  "spot.prediction.hw": "Dispoziční akumulace bojleru",
  "spot.prediction.pv": "Výroba elektrárny",
  "spot.prediction.sale": "Zbývající energie pro prodej přebytků",
  "spot.prediction.sale.help": "Zbývající plánovaná denní výše přebytků, která bude upřednostněna jako přetok do sítě před akumulací do baterie.",
  "spot.price.period.15min": "15 min",
  "spot.price.period.60min": "60 min",
  "spot.region.cz": "CZ",
  "spot.region.nl": "NL",
  "spot.region.sk": "SK",
  "spot.status": "Spotové obchodování",
  "spot.summary.battery_charge_from_grid": "Nabíjení ze sítě",
  "spot.summary.battery_charge_from_grid.help": "Nabíjení baterie ze sítě dle spotu je možné zakázat či povolit. Lze tak udělat v nastavení. Nabíjení baterie systém naplánuje v době nízkých cen a bere v potaz aktuální úroveň nabití baterie a její kapacitu. Na základě těchto parametrů zvolí délku nabíjení tak, aby došlo k jejímu plnému nabití za co nejnižší cenu.",
  "spot.summary.battery_discharge": "Vybíjení baterie",
  "spot.summary.battery_discharge.help": "Vybíjení baterie do objektu na spotu je možné zakázat či povolit. Lze tak udělat v nastavení. Vybíjení baterie se obvykle zakazuje v době nízkých cen, kdy je lepší brát energii ze sítě a v baterii ji uchovat na dražší časy.",
  "spot.summary.battery_discharge_to_grid": "Vybíjení do sítě",
  "spot.summary.battery_discharge_to_grid.help": "Vybíjení baterie do sítě je možné zakázat či povolit. Lze tak udělat v nastavení. Vybíjení baterie do sítě určí systém v době nejvyšší denní ceny a vybije jen tu energii, která nebude potřeba na běžnou spotřebu objektu.",
  "spot.summary.boiler": "Bojler",
  "spot.summary.boiler.help": "Nahřívání bojleru systém naplánuje v době nízkých cen a bere v potaz aktuální teplotu vody v bojleru, jeho kapacitu a požadovanou teplotu. Na základě těchto parametrů zvolí délku nahřívání tak, aby došlo k jeho nahřátí.",
  "spot.summary.heat_pump": "Tepelné čerpadlo",
  "spot.summary.heat_pump.help": "Tepelné čerpadlo může běžet ve třech režimech: zvýšený výkon, běžný chod a omezený výkon. Zvýšený výkon se využívá v době nízkých cen, běžný chod v době středních cen a omezený výkon v době vysokých cen. Odložení spotřeby či zvýšení spotřeby lze povolit v menu tepelného čerpadla.",
  "spot.summary.heat_pump_level.increase": "Zýšený výkon",
  "spot.summary.heat_pump_level.normal": "Běžný chod",
  "spot.summary.heat_pump_level.reduction": "Omezený výkon",
  "spot.summary.price": "Cena",
  "spot.summary.price_buy": "Cena s distribucí",
  "spot.summary.price_distribution": "Distribuce",
  "spot.summary.price_level": "Hladina ceny",
  "spot.summary.price_level.help": "Infigy seřadí hodinové ceny spotu od nejnižší po nejvyšší a rozdělí je do tří částí, přibližně stejně velkých. Pokud hodinnové ceny začínají na hodnotě 3 Kč a končí na hodnotě 10 Kč, tak nízká cena může mít roztpyl 3-6 Kč, střední 6-7 Kč a vysoká 7-10 Kč. Rozptyl bude každý den jiný, záleží na četnosti hodnot v dané cenové hladině.",
  "spot.summary.price_level.hi": "Vysoká cena",
  "spot.summary.price_level.low": "Nízká cena",
  "spot.summary.price_level.mid": "Střední cena",
  "spot.summary.price_level_15m": "Hladina ceny 15m",
  "spot.summary.price_sell": "Cena bez distribuce",
  "spot.summary.spotOverflow": "Přetok do sítě",
  "spot.summary.spotOverflow.allowed": "Povolený",
  "spot.summary.spotOverflow.help": "Povolení přetoku do sítě při spotovém obchodování porovnává cenu spotu v danou hodinu a pokud je nižší než Cena pro zákaz přetoků z nastavení, tak systém automaticky v danou hodinu přetok zakáže.",
  "spot.summary.spotOverflow.restricted": "Omezený",
  "spot.summary.state.active": "Aktivní",
  "spot.summary.state.inactive": "Neaktivní",
  "spot.summary.time": "Čas",
  "spot.user.parameters": "Parametry spotového obchodování",
  "spot_wizard.banner.button": "Chci poradit",
  "spot_wizard.banner.subtitle": "Průvodce vám pomůže s nastavením spotového obchodování.",
  "spot_wizard.banner.title": "Tápete? Poradím Vám",
  "spot_wizard.battery_discharge.paragraph1": "Toto nastavení zakáže vybíjení baterie při nízké ceně spotu. Díky tomu si uchováte energii pro vyšší ceny dne.",
  "spot_wizard.battery_discharge.paragraph2": "Pokud máte pouze prodej energie na spotu, můžete zákaz deaktivovat.",
  "spot_wizard.battery_discharge.title": "Vybíjení baterie do vlastní spotřeby",
  "spot_wizard.battery_purchase.paragraph1": "Toto nastavení umožní při nízké výrobě elektrárny nabít baterii z nízkého spotu.",
  "spot_wizard.battery_purchase.paragraph2": "Věnujte pozornost nastavení strategie. Pokud nastavíte 20%, Infigy bude spíše čekat na fotovoltaiku. Naopak při nastavení 70% bude spíše nakupovat na spotu. Doporučujeme nastavit 25%.",
  "spot_wizard.battery_purchase.paragraph3": "Pokud máte pouze prodej energie na spotu, můžete nabíjení deaktivovat.",
  "spot_wizard.battery_purchase.title": "Nákup energie do baterie",
  "spot_wizard.boiler.paragraph1": "Toto nastavení umožní při nízké výrobě elektrárny ohřát bojler z nejlevnějších cen dne do nastavené teploty. Infigy stále udržuje základní teplotu a využívá navýšení teploty na teplotu ze spotu.",
  "spot_wizard.boiler.paragraph2": "Zároveň je možné blokovat ohřev při střední a nebo vysoké ceně.",
  "spot_wizard.boiler.paragraph3": "Pokud máte pouze prodej energie na spotu, můžete teplotu nastavit na 10°C a deaktivovat blokaci ohřevu.",
  "spot_wizard.boiler.title": "Ohřev bojleru",
  "spot_wizard.dialog.finish": "Dokončit",
  "spot_wizard.dialog.next": "Další",
  "spot_wizard.dialog.prev": "Zpět",
  "spot_wizard.dialog.step": "Krok {current} z {total}",
  "spot_wizard.dialog.title": "Průvodce nastavením spotu",
  "spot_wizard.distribution_prices.title": "Zadejte cenu za distribuci v nízkém a vysokém tarifu",
  "spot_wizard.done.description": "Prošli jste nastavení spotu. Veškeré parametry lze upravit ve spodní části stránky Spot, kde můžete i opět vyvolat tohoto průvodce.",
  "spot_wizard.done.title": "Hotovo",
  "spot_wizard.evening_peak_discharge.paragraph1": "Infigy automaticky odhadne spotřebu energie do ranních hodin. Nadbytek může být prodán za nejvyšší cenu dne.",
  "spot_wizard.evening_peak_discharge.paragraph2": "Pokud máte pouze nákup energie na spotu, můžete vybíjení deaktivovat.",
  "spot_wizard.evening_peak_discharge.title": "Vybíjení baterie při večerní špičce",
  "spot_wizard.general_settings.title": "Nejprve obecné nastavení",
  "spot_wizard.hdo_times.title": "Nastavení HDO časů určí období nízkého tarifu",
  "spot_wizard.heat_pump.paragraph1": "Toto nastavení umožní při nízké výrobě elektrárny navyšovat výkon tepelného čerpadla při nízké ceně a naopak snižovat výkon při vysoké ceně.",
  "spot_wizard.heat_pump.paragraph2": "Pokud máte pouze prodej energie na spotu, odložení i výšení spotřeby deaktivovat.",
  "spot_wizard.heat_pump.title": "Tepelné čerpadlo",
  "spot_wizard.info.button1": "Proč se mi dnes nenabila baterie ze spotu?",
  "spot_wizard.info.button2": "Proč se mi dnes nevybíjela baterie do spotu?",
  "spot_wizard.info.button3": "Chci pomoc s nastavením",
  "spot_wizard.info.help1.title": "Proč se mi dnes nenabila baterie ze spotu?",
  "spot_wizard.info.help2.title": "Proč se mi dnes nevybíjela baterie do spotu?",
  "spot_wizard.info.title": "Informace ke spotu",
  "spot_wizard.overflow_limit.paragraph1": "Pokud máte spot pouze pro nákup energie, můžete nastavit -10 Kč. Přetok je omezen na maximální velikost nastavenou servisním technikem.",
  "spot_wizard.overflow_limit.paragraph2": "Pokud máte spot i pro prodej energie, je výhodné zastavit akumulaci při ceně, která odpovídá provizi Vašeho dodavatele. Provize bývá nejčastěji 0.30 - 0.70 Kč/kWh.",
  "spot_wizard.overflow_limit.title": "Omezení přetoku do sítě",
  "spot_wizard.preferential_sale.paragraph1": "Tato funkce umožní zákaz ukládání energie při ranní špičce. Dojde k deaktivaci nabíjení baterie, bojleru a tepelného čerpadla. Akumulace se aktivuje při nízké ceně nebo při prodání odhadovaného přebytku energie.",
  "spot_wizard.preferential_sale.paragraph2": "Pokud máte pouze nákup energie na spotu, můžete funkci deaktivovat.",
  "spot_wizard.preferential_sale.title": "Přednostní prodej energie",
  "statistics.battery.statistics": "Úroveň nabití baterie",
  "statistics.boiler.statistics": "Ohřev bojleru elektrokotlem",
  "statistics.electrical_grid.statistics": "Nákup z distribuční sítě",
  "statistics.electrical_grid.statistics_house_consumption": "Spotřeba objektu",
  "statistics.electrical_grid.statistics_overflow": "Přetok do distribuční sítě",
  "statistics.heatpump.statistics": "Spotřeba kompresoru",
  "statistics.outdoor_temperature.statistics": "Venkovní teplota",
  "statistics.photovoltaics.statistics": "Výroba elektrárny",
  "statistics.plug.statistics": "Spotřeba zásuvky",
  "statistics.wind.statistics": "Výroba větrné elektrárny",
  "stats_delete.button": "Smazat",
  "stats_delete.cancel": "Zrušit",
  "stats_delete.confirm": "Smazat",
  "stats_delete.confirm.title": "Opravdu chcete smazat všechny statistiky?",
  "stats_delete.title": "Smazat všechny statistiky",
  "stats_export.button": "Export",
  "stats_export.from": "Od",
  "stats_export.metric": "Metrika",
  "stats_export.title": "Exportovat statistiky",
  "stats_export.to": "Od",
  "status.heatWater.flexibility": "Flexibilita aktivní, vytápění teplé vody",
  "status.heatWater.heating": "Vytápění teplé vody",
  "status.heatWater.hwError": "Bojler je nahřátý nebo nedostupný",
  "status.heatWater.inverterError": "Předehřev bojleru neaktivní, není dostupný střídač",
  "status.heatWater.legionella": "Sanace vody",
  "status.heatWater.notConnected": "Nelze navázat spojení",
  "status.heatWater.notLicensed": "Řízení bojleru není licencované",
  "status.heatWater.off": "Vypnuto",
  "status.heatWater.overload": "Přetížení sítě, vytápění zastaveno",
  "status.heatWater.pvHeating": "Vytápění z přebytků",
  "status.heatWater.smartMeterError": "Předehřev bojleru neaktivní, není dostupný elektroměr",
  "status.heatWater.spotHeating": "Vytápění teplé vody ze spotu",
  "status.heatWater.stop": "STOP",
  "status.heatWater.stopHDO": "Ohřev blokován při vysokém tarifu",
  "status.heatWater.stopSOC": "Blokace vytápění, nízký stav baterie",
  "status.heatWater.stopSell": "Předehřev blokován, prodej energie",
  "status.heatWater.tempError": "Teplotní čidlo není dostupné",
  "status.photovoltaic.dischargeBlockedByComponents": "Vybíjení baterie pozastaveno kvůli spotřebě vybraných technologií",
  "status.photovoltaic.dischargeBlockedByHDO": "Vybíjení baterie pozastaveno, aktivní vysoký tarif (HDO)",
  "status.photovoltaic.discharging": "Vybíjení baterie",
  "status.photovoltaic.distributionLimit": "Distribuce omezuje výkon",
  "status.photovoltaic.feedInPriority": "Priorita přetoku do sítě",
  "status.photovoltaic.flexibilityBatteryStop": "Flexibilita aktivní, zastaveno vybíjení i nabíjení baterie",
  "status.photovoltaic.flexibilityCharging": "Flexibilita aktivní, nabíjení baterie ze sítě",
  "status.photovoltaic.flexibilityDischarging": "Flexibilita aktivní, vybíjení baterie do sítě",
  "status.photovoltaic.flexibilityDoNotDischarge": "Flexibilita aktivní, zákaz vybíjení baterie",
  "status.photovoltaic.flexibilityFeedInPriority": "Flexibilita aktivní, priorita přetoku do sítě",
  "status.photovoltaic.flexibilityOverflowRestricted": "Flexibilita aktivní, zákaz přetoku do sítě",
  "status.photovoltaic.forcedOverflow": "Flexibilita aktivní, vynucený přetok do sítě",
  "status.photovoltaic.idle": "Režim spánku",
  "status.photovoltaic.manualCharging": "Ruční nabíjení baterie",
  "status.photovoltaic.manualDischarging": "Ruční vybíjení baterie",
  "status.photovoltaic.noneInverter": "Typ střídače nenastaven",
  "status.photovoltaic.notConnected": "Nelze navázat spojení",
  "status.photovoltaic.notLicensed": "Řízení FVE není licencovaná",
  "status.photovoltaic.planCharge": "Plánované nabíjení baterie",
  "status.photovoltaic.planDischarge": "Plánované vybíjení baterie",
  "status.photovoltaic.production": "Výroba energie",
  "status.photovoltaic.sellBatteryEnergy": "Prodej energie z baterie",
  "status.photovoltaic.spotCharging": "Nabíjení baterie ze spotu",
  "status.photovoltaic.spotStopDischarging": "Zastaveno vybíjení, je nízká cena na spotu",
  "status.photovoltaic.standby": "Stand-by režim",
  "status.photovoltaic.startUp": "Startovací režim",
  "status.plug.batteryControl": "Zásuvka aktivní podle baterie",
  "status.plug.manualControl": "Zásuvka aktivní v manuálním módu",
  "status.plug.notActive": "Zásuvka neaktivní",
  "status.plug.notConnected": "Zásuvka není dostupná",
  "status.plug.overflowControl": "Zásuvka aktivní podle přetoku",
  "status.plug.spotControl": "Zásuvka aktivní podle spotu",
  "status.plug.stop": "STOP",
  "status.plug.timeControl": "Zásuvka aktivní podle času",
  "status.smartMeter.consumption": "Běžný odběr domu",
  "status.smartMeter.maxLoad": "Maximální odběr domu",
  "status.smartMeter.none": "",
  "status.smartMeter.overflow": "Přetok energie",
  "status.smartMeter.overflowLimited": "Přetok omezen z důvodu záporné ceny",
  "status.smartMeter.shortage": "Výpadek distribuční sítě",
  "status.spotBattery.flexibilityPV": "Flexibilita využita pro FVE",
  "status.spotBattery.flexibilitySpot": "Flexibilita využita pro SPOT",
  "status.spotBattery.noData": "Pro řízení nejsou aktuální data",
  "status.spotBattery.spotNotLicensed": "Spot není licencovaný",
  "status.spotBatteryChargeFromGrid.batteryChargingNotActive": "Není aktivované nabíjení ze sítě",
  "status.spotBatteryChargeFromGrid.batteryChargingPlanned": "Dnes je nabíjení aktivní",
  "status.spotBatteryChargeFromGrid.enoughPVEnergy": "Dnes se očekává denní přebytek pro nabití baterie",
  "status.spotBatteryChargeFromGrid.priceDifferenceTooLow": "Dnes není splněný minimální rozdíl ceny",
  "status.spotBatteryChargeFromGrid.spotNotActive": "Není aktivní spotové obchodování",
  "status.spotBatteryDischargeToGrid.batteryDischargingNotActive": "Není aktivované vybíjení do sítě",
  "status.spotBatteryDischargeToGrid.batteryDischargingPlanned": "Dnes je vybíjení aktivní",
  "status.spotBatteryDischargeToGrid.minPriceNotReached": "Dnes není splněná minimální cena pro prodej",
  "status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy": "Dnes se očekává vybití baterie přes noc do vlastní spotřeby",
  "status.spotBatteryDischargeToGrid.spotNotActive": "Není aktivní spotové obchodování",
  "status.spotBatteryDischargeToHome.automaticDischargeMode": "Automatické vybíjení baterie dle kapacity",
  "status.spotBatteryDischargeToHome.highPriceDischargeMode": "Vybíjení baterie při vysoké ceně",
  "status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode": "Vybíjení baterie při střední a vysoké ceně",
  "status.spotBatteryDischargeToHome.notControlled": "Vybíjení baterie není omezeno",
  "status.spotHeatPump.flexibilityPV": "Flexibilita využita pro FVE",
  "status.spotHeatPump.flexibilitySpot": "Flexibilita využita pro SPOT",
  "status.spotHeatPump.noData": "Pro řízení nejsou aktuální data",
  "status.spotHeatPump.spotNotLicensed": "Spot není licencovaný",
  "status.spotHeatWater.flexibilityPV": "Flexibilita využita pro FVE",
  "status.spotHeatWater.flexibilitySpot": "Flexibilita využita pro SPOT",
  "status.spotHeatWater.noData": "Pro řízení nejsou aktuální data",
  "status.spotHeatWater.spotNotLicensed": "Spot není licencovaný",
  "status.spotSmartMeter.noData": "Pro řízení nejsou aktuální data",
  "status.spotSmartMeter.overflowDisabled": "Trvalé omezení přetoku",
  "status.spotSmartMeter.overflowFlexibilitySell": "Optimalizace přetoku pro prodej",
  "status.spotSmartMeter.overflowLimited": "Přetok omezen z důvodu záporné ceny",
  "status.spotSmartMeter.spotNotLicensed": "Spot není licencovaný",
  "status.spotSmartMeter.withoutReduction": "Bez omezení",
  "status.wind.production": "Výroba energie",
  "status.wind.stop": "STOP",
  "status.wind.unavailable": "Zařízení není dostupné",
  "subscriptions.fetch": "Aktualizovat předplatné",
  "subscriptions.fetch.button": "Aktualizovat předplatné",
  "subscriptions.last_fetch_at": "Poslední aktualizace",
  "subscriptions.premium_active": "Premium aktivní",
  "subscriptions.title": "Předplatné",
  "test-product.app": "Aplikace",
  "test-product.settings": "Nastavení",
  "test-product.settings.distribution": "Distribuce",
  "test-product.settings.distribution.Dzd": "DZD",
  "test-product.settings.distribution.Infigy": "Infigy",
  "test-product.settings.distribution.solid_sun": "SolidSun",
  "test-product.settings.license": "Licence",
  "test-product.settings.license.HW": "HW",
  "test-product.settings.license.Industrial": "Industrial",
  "test-product.settings.license.Play": "PLAY",
  "test-product.settings.license.Smart": "Smart",
  "test-product.settings.license.basic": "Basic",
  "test-product.test": "Test zařízení",
  "test-product.test.DC": "Kontrola DC obvodu",
  "test-product.test.DC.subtitle": "Dotažení svorek, dimenze kabelů",
  "test-product.test.component": "Kontrola komponentů",
  "test-product.test.component.subtitle": "Je přibaleno čidlo, štítky, ...?",
  "test-product.test.electricmeter": "Kontrola elektroměru",
  "test-product.test.electricmeter.subtitle": "Kontrola osazení elektroměru pro střídač",
  "test-product.test.internet-connect": "Připojení k internetu",
  "test-product.test.inverter-connect": "Připojení střídače",
  "test-product.test.license": "Licence",
  "test-product.test.license-info": "Test skončí za:",
  "test-product.test.phase_1": "Test 1. fáze",
  "test-product.test.phase_2": "Test 2. fáze",
  "test-product.test.phase_3": "Test 3. fáze",
  "test-product.test.serialNumber": "Výrobní číslo jednotky",
  "test-product.test.serialNumber.label": "Sériové číslo",
  "test-product.test.serialNumber.subtitle": "Bez výrobního čísla nelze zadat jméno testera a aktivovat test",
  "test-product.test.serialNumberSwitchboard": "Výrobní číslo rozvaděče",
  "test-product.test.serialNumberSwitchboard.label": "Sériové číslo",
  "test-product.test.serialNumberSwitchboard.subtitle": "Vyplnit v případě, že je zařízení v originálním rozvaděči",
  "test-product.test.start": "Pokud je zařízení připojeno",
  "test-product.test.start.button": "Aktivovat test",
  "test-product.test.switchboard": "Kontrola shody rozvaděče",
  "test-product.test.switchboard.subtitle": "Kontrola dotažení svorek, umístění komponentů, správné dimenze kabelů",
  "test-product.test.temp": "Teplotní čidlo",
  "test-product.test.tester": "Zařízení otestoval",
  "test-product.test.tester.subtitle": "Bez jména nelze aktivovat test",
  "thermostat.general": "Společné nastavení",
  "thermostat.general.cooling": "Chlazení aktivní",
  "thermostat.general.cooling.pvstability": "Potenciál aktivace zdroje",
  "thermostat.general.heating": "Vytápění aktivní",
  "thermostat.range": "Termostat",
  "thermostat.range.flexibility-temperature": "Flexibilní teplota",
  "thermostat.range.flexibility-temperature.subtitle": "Teplota o kterou je možné předehřát nebo předchladit dům",
  "thermostat.range.flexibility_status": "Režim flexibility termostatu",
  "thermostat.range.on": "Termostat aktivní",
  "thermostat.range.on.subtitle": "Základní teplota",
  "thermostat.range.pv-flexibility": "Řízení podle fotovoltaiky",
  "thermostat.range.set_temperature": "Nastavená teplota",
  "thermostat.range.sp-flexibility-down": "Odložení spotřeby podle spotu",
  "thermostat.range.sp-flexibility-up": "Zvýšení spotřeby podle spotu",
  "thermostat.range.status": "Režim termostatu",
  "thermostat.range.temperature": "Aktuální teplota",
  "thermostat.status": "Režim termostatu",
  "wallbox.3a.on": "Mód 3A",
  "wallbox.3a.on_sub": "Nabíjení může brát 3A z distribuční sítě",
  "wallbox.6a.on": "Mód 6A",
  "wallbox.6a.on_sub": "Nabíjení lze pouze z FVE",
  "wallbox.NO_CHARGE": "Nenabíjej",
  "wallbox.NO_CHARGE.on_sub": "Nabíjení je trvale blokováno, spustí jej pouze časový plán",
  "wallbox.PV": "Nabíjení podle baterie",
  "wallbox.PV.batteryStart": "Zapnout při nabití",
  "wallbox.PV.batteryStart.subtitle": "Nabití baterie při kterém se aktivuje nabíjení",
  "wallbox.PV.batteryStop": "Vypnout při nabití",
  "wallbox.PV.batteryStop.subtitle": "Nabití baterie při kterém se vypne nabíjení",
  "wallbox.PV.on_sub": "Po dosažení základní energie dojde k nabíjení pouze při nabité baterii",
  "wallbox.PV2": "Nabíjení podle FVE",
  "wallbox.PV2.on_sub": "Řízení nabíjení podle výkonu FVE",
  "wallbox.PV_FAST": "Přednostní nabíjení podle baterie",
  "wallbox.PV_FAST.batteryMinSoc": "Minimální rezerva baterie",
  "wallbox.PV_FAST.batteryMinSoc.subtitle": "Baterie se kvůli nabíjení automobilu nevybije pod tuto hodnotu. Dokud není hodnota překročena, nabíjení čeká",
  "wallbox.PV_FAST.on_sub": "Nabíjení automobilu bude zcela prioritní. Bude využívána pouze energie z baterie nebo FVE",
  "wallbox.SPOT": "Nabíjení podle spotu",
  "wallbox.SPOT.hi": "Blokovat nabíjení při vysoké ceně",
  "wallbox.SPOT.mi": "Blokovat nabíjení při střední ceně",
  "wallbox.SPOT.on_sub": "Po dosažení základní energie dojde k blokování při vysoké ceně spotu",
  "wallbox.active": "{name}",
  "wallbox.active.subtitle": "Aktivní",
  "wallbox.alfen": "Alfen",
  "wallbox.authorization.status": "Autorizace",
  "wallbox.authorization.status.authorized": "Autorizováno{cardInfo}",
  "wallbox.authorization.status.denied": "Zamítnuto{cardInfo}",
  "wallbox.authorization.status.pending": "Není autorizováno",
  "wallbox.authorization.status.unknown": "Neznámý stav",
  "wallbox.az_router": "AZ Router",
  "wallbox.common": "Obecné informace",
  "wallbox.common.power": "Aktuální spotřeba",
  "wallbox.common.power_today": "Dnešní spotřeba:",
  "wallbox.common.power_total": "Celková spotřeba",
  "wallbox.common.power_year": "Roční spotřeba:",
  "wallbox.control": "Režim nabíjení",
  "wallbox.ecovolter": "EcoVolter",
  "wallbox.evmate": "EVmate",
  "wallbox.fast-charge.energy": "Energie pro rychlé nabití",
  "wallbox.fast-charge.energy_actual": "Aktuální cyklus:",
  "wallbox.fast-charge.energy_sub": "Energie, která je vždy co nejrychleji nabita. Po dosažení této hodnoty je nabití řízeno jedním z režimů",
  "wallbox.goodwe-ev-charger": "Goodwe",
  "wallbox.inactive.subtitle": "Neaktivní",
  "wallbox.mode.pv.batteryStopConflict.description": "Pokud je zapnutá blokace baterie při provozu wallboxu, nelze zapnout režim „Nabíjení podle baterie“. Pro zapnutí režimu „Nabíjení podle baterie“ je nutné nejprve vypnout blokaci baterie na stránce „Fotovoltaika“.",
  "wallbox.mode.pv.batteryStopConflict.title": "Režim nelze zapnout",
  "wallbox.mybox": "MyBox",
  "wallbox.none": "Žádný",
  "wallbox.nonemode": "Běžné nabíjení",
  "wallbox.nonemode.amper-auto": "Automatické řízení nabíjecího proudu",
  "wallbox.nonemode.amper-auto.subtitle": "Řídí nabíjení aby se minimalizovalo nabíjení a vybíjení baterie",
  "wallbox.nonemode.ampers": "Maximální nabíjecí proud",
  "wallbox.nonemode.hdo": "Nabíjení pouze při nízkém tarifu",
  "wallbox.nonemode.hdo_sub": "Časy pro HDO musí být nastaveny v obecném nastavení",
  "wallbox.nonemode.on_sub": "Auto se nabíjí co nejrychleji",
  "wallbox.olife": "Olife",
  "wallbox.other": "Ostatní",
  "wallbox.pv.ampers-auto": "Aktuální požadovaný nabíjecí proud",
  "wallbox.schedules.description": "Naplánujte si nabíjení elektromobilu podle potřeby.",
  "wallbox.schedules.title": "Plánovač nabíjení",
  "wallbox.settings": "Nastavení",
  "wallbox.solax": "Solax - komunikace přes střídač",
  "wallbox.solax-ev-charger": "Solax - komunikace přes Infigy",
  "wallbox.statistics": "Statistiky",
  "wallbox.status": "Režim Wallboxu",
  "wallbox.status.car_not_connected": "Auto není připojeno",
  "wallbox.status.charging": "Nabíjení",
  "wallbox.status.charging_with_ventilation": "Nabíjení auta s ventilátorem",
  "wallbox.status.error": "Chyba nabíjení",
  "wallbox.status.home": "Režim wallboxu",
  "wallbox.status.normal": "Běžný režim",
  "wallbox.status.not_connected": "Nelze navázat spojení",
  "wallbox.status.off": "Wallbox vypnutý",
  "wallbox.status.ready": "Připraveno k nabíjení",
  "wallbox.sub_status.auto": "podle auto. režimu",
  "wallbox.sub_status.basic_energy": "základní energií",
  "wallbox.sub_status.battery": "podle baterie",
  "wallbox.sub_status.battery_fast": "přednostně podle baterie",
  "wallbox.sub_status.battery_waiting": ", čekání na nabítí baterie",
  "wallbox.sub_status.hdo_block": ", blokace HDO",
  "wallbox.sub_status.no_charging": ", nabíjení je zakázáno",
  "wallbox.sub_status.none": "",
  "wallbox.sub_status.photovoltaics": "podle FVE",
  "wallbox.sub_status.schedule": "podle plánovače",
  "wallbox.sub_status.spot": "podle SPOTU",
  "wallbox.sub_status.spot_high": ", je vysoká cena SPOTU",
  "wallbox.sub_status.spot_mid": ", je střední cena SPOTU",
  "wallbox.victron-ev-charger": "Victron EV Charger",
  "wallbox.wallboxes.title": "Wallboxy",
  "wallbox_rfid.add_button": "Přidat RFID kartu",
  "wallbox_rfid.delete.cancel": "Zrušit",
  "wallbox_rfid.delete.confirm": "Smazat",
  "wallbox_rfid.delete.confirm.title": "Smazat kartu {name}?",
  "wallbox_rfid.dialog.already_exists": "Karta {id} je již uložena pod názvem {name}.",
  "wallbox_rfid.dialog.already_exists_hint": "Přiložte jinou kartu nebo zavřete dialog.",
  "wallbox_rfid.dialog.cancel": "Zrušit",
  "wallbox_rfid.dialog.name_label": "Název karty",
  "wallbox_rfid.dialog.save": "Uložit",
  "wallbox_rfid.dialog.scanned_id": "ID karty: {id}",
  "wallbox_rfid.dialog.title": "Přidat RFID kartu",
  "wallbox_rfid.dialog.waiting": "Přiložte kartu ke čtečce…",
  "wallbox_rfid.edit.dialog.title": "Upravit RFID kartu",
  "wallbox_wizard.cancel": "Zrušit",
  "wallbox_wizard.custom_device_ip_address.alert": "Ujistěte se prosím, že se IP adresa wallboxu nebude měnit (např. když wallbox využívá adresu z DHCP).",
  "wallbox_wizard.custom_device_ip_address.input": "IP adresa wallboxu",
  "wallbox_wizard.multiple_wallboxes.alert": "Pro nastavení více wallboxů prosím kontaktujte linku podpory. Kontakt najdete v technické wiki Infigy.",
  "wallbox_wizard.multiple_wallboxes.label": "Více wallboxů",
  "wallbox_wizard.open": "Nastavit wallbox",
  "wallbox_wizard.save": "Uložit",
  "wallbox_wizard.title": "Nastavení wallbox",
  "welcome.subtitle": "Aplikace pro domácí a moderní energetiku na jednom místě! Lorem ispum dolor sit anem",
  "welcome.title": "Vítejte v Infigy!",
  "wifi_ap_config.interface_block.confirm.confirmation_text": "{blocked, select, true {Zablokovat} other {Odblokovat}}",
  "wifi_ap_config.interface_block.confirm.content": "Opravdu chcete {blocked, select, true {zablokovat} other {odblokovat}} WiFi?",
  "wifi_ap_config.interface_block.confirm.title": "Změna stavu WiFi",
  "wifi_ap_config.passphrase_change.confirm.passphrase": "Heslo",
  "wifi_ap_config.passphrase_change.confirm.title": "Změna hesla k WiFi",
  "wifi_ap_config.wifi_interface_blocked.button": "{blocked, select, true {Odblokovat} other {Zablokovat}}",
  "wifi_ap_config.wifi_interface_blocked.title": "Stav WiFi",
  "wifi_ap_config.wifi_interface_blocked.value": "{blocked, select, true {Zablokován} other {Aktivní}}",
  "wind.common": "Obecné informace",
  "wind.common.battery_charged_total": "Celkem do baterie:",
  "wind.common.battery_power": "Výkon do baterie",
  "wind.common.power": "Aktuální výkon",
  "wind.common.power_today": "Dnešní výroba:",
  "wind.common.power_total": "Celková výroba",
  "wind.common.power_year": "Roční výroba:",
  "wind.common.resistor_power": "Výkon do odporu",
  "wind.statistics": "Statistiky",
  "wind.statistics.power": "Výkon větrné elektrárny",
  "wind.statistics.wind_speed": "Rychlost větru",
  "wind.status": "Režim větrné elektrárny"
}